export default {
  app: {
    whatsapp: {
      title: "WhatsApp",
      ariaLabel: "Contact via WhatsApp",
      cta: "Contact us",
      prefilledMessage: "Hi, I'd like to transform my content into clips using Clipr.",
      prompt: "Questions? Contact us 24/7 😉",
    },
  },
  common: {
    language: "Language",
    spanish: "Spanish",
    english: "English",
    error: "Error",
    loading: "Loading...",
    refresh: "Refresh",
    saveChanges: "Save changes",
    saving: "Saving...",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    ago: "ago",
    in: "in",
    month: "month",
    noActiveSession: "No active session.",
    loginFirst: "Please log in first.",
    unexpectedError: "Unexpected error",
    today: "Today",
    manage: "Manage",
    assign: "Assign",
    save: "Save",
    edit: "Edit",
    back: "Back",
    cancel: "Cancel",
    delete: "Delete",
    close: "Close",
    loadMore: "Load more",
    stop: "Stop",
    period: "Period",
    scope: "Scope",
    filters: "Filters",
    admin: "Admin",
    ready: "Ready",
    filterByUsername: "Filter by username",
    filterByNameOrEmail: "Filter by name or email",
    refreshPageHint: "Something went wrong while loading the page. Please refresh the page.",
    comingSoon: "Coming soon",
    disconnected: "Disconnected",
    enabled: "Enabled",
    disabled: "Disabled",
    yes: "Yes",
    no: "No",
    retry: "Retry",
    demoReadOnly: "Read-only demo.",
  },
  navbar: {
    impersonationActive: "Impersonation active",
    impersonating: "Impersonating",
    stopImpersonating: "Stop impersonating",
    tokensAvailable: "Available tokens",
    tokenPriceHint: "1 token = 1 minute",
    tokensWord: "tokens",
    menuTokens: "Tokens",
    menuProfile: "Profile",
    menuLanguage: "Language",
    profileMenuAria: "Account menu",
    planLabelPrefix: "Plan: ",
    impersonationEnded: "Impersonation ended.",
  },
  results: {
    title: "Results",
    subtitle: "Jobs with rendered clips",
    jobs: "job",
    pageShort: "pg.",
    updated: "Updated",
    loading: "Loading results...",
    retry: "Retry",
    emptyTitle: "No rendered clips to display",
    emptyHint: "This screen shows clips with",
    emptyHintSuffix: "not null, grouped by",
    clip: "clip",
    rendered: "Rendered",
    openHint: "Click a job to open its public page with rendered URLs.",
    loadError: "Could not load collections.",
    genericError: "Error loading results. Please try again.",
  },
  billing: {
    tokenBalance: "Token balance",
    currentBalance: "Current balance",
    tokenEquivalencyHint: "1 token = 1 minute",
    tokenRenderEquivalencyHint: "1 token = 1 minute of rendering",
    tokenRenderExampleHint: "E.g. rendering one 1.5-hour stream uses 90 tokens",
    renderHoursAvailable: "approx. {hours} h rendering",
    tokens: "tokens",
    refreshing: "Refreshing...",
    refresh: "Refresh",
    purchaseStatus: "Purchase status",
    reference: "Reference",
    order: "Order",
    subscriptionId: "Subscription",
    subscriptionRequest: "Subscription request",
    subscriptionStatusTitle: "Subscription status",
    subscriptionStatusLabel: "Status",
    noActiveSubscription: "No active subscription",
    noActiveSubscriptionHelp: "You do not have an active subscription yet. You can start one from the plans below.",
    currentPlan: "Current plan",
    currentPlanDetails: "This is your active subscription right now.",
    activeSubscriptionBlocksPlanPurchase: "You already have an active subscription. Manage your plan from the subscription status.",
    startSubscription: "Start subscription",
    subscriptionPending: "Pending",
    subscriptionActive: "Active",
    subscriptionPaused: "Paused",
    subscriptionCanceled: "Canceled",
    subscriptionFailed: "Payment failed",
    subscriptionExpiresOn: "Expires on {date}",
    subscriptionBenefitsActive: "Benefits active",
    subscriptionBenefitsActiveUntil: "Access active until {date}",
    subscriptionRenewsOn: "Renews on {date}",
    paymentGraceEndsOn: "Grace period until {date}",
    successfulPayments: "Successful payments",
    grantedTokens: "Granted tokens",
    renewalPaymentIssueTitle: "There is a renewal payment issue",
    renewalPaymentIssuePaused: "Your subscription is paused because we could not complete the renewal. Update your payment method to reactivate it and keep your benefits.",
    renewalPaymentIssueFailed: "We could not complete the renewal. Update your payment method or make sure your card has enough balance to avoid losing your benefits.",
    updatePaymentMethod: "Update payment method",
    updatingPaymentMethod: "Updating...",
    updatePaymentMethodCta: "Save card and retry charge",
    paymentMethodUpdateSummary: "Let's keep your subscription active",
    unableToUpdatePaymentMethod: "Unable to update your payment method.",
    paymentMethodUpdateConfirmed: "Your payment method was updated and the charge was confirmed.",
    paymentMethodUpdateFailed: "Your card was updated, but the charge still could not be confirmed. Review the details or try another card.",
    legacyPlanBannerTitle: "Your plan is no longer available",
    legacyPlanBannerFallbackText: "Your current plan is no longer available for new purchases. You will keep your current benefits until you cancel or change your plan.",
    refreshSubscriptionStatus: "Retry status check",
    manageSubscription: "Manage your subscription",
    cancelSubscription: "Cancel subscription",
    cancelSubscriptionTitle: "Cancel subscription",
    cancelSubscriptionPrompt: "Your feedback helps us improve Clipr.",
    cancelReasonLabel: "Cancellation reason",
    cancelReasonPlaceholder: "Select a reason",
    cancelReasonPrice: "The price is too high",
    cancelReasonUsage: "I do not use Clipr enough",
    cancelReasonFeatures: "I could not find the features I need",
    cancelReasonTechnical: "I had technical problems",
    cancelReasonOther: "Other reason",
    cancelMessageLabel: "Tell us more",
    cancelMessagePlaceholder: "Write your cancellation reason here",
    cancelReasonRequired: "Select a reason and write a message to continue.",
    confirmCancellation: "Confirm cancellation",
    cancellingSubscription: "Cancelling...",
    unableToStartSubscription: "Unable to start subscription.",
    unableToUpgradeSubscription: "Unable to upgrade subscription.",
    unableToCancelSubscription: "Unable to cancel subscription.",
    subscriptionStartPending: "Your subscription was started and is pending confirmation.",
    subscriptionUpgradePending: "Your plan change was requested and is pending confirmation.",
    subscriptionUpgradeConfirmed: "Your plan change was confirmed and your new plan is now active.",
    subscriptionActiveNotice: "Your subscription is now active and ready to use.",
    subscriptionCancelledNotice: "Subscription cancelled successfully.",
    checkoutSuccessTitle: "All set",
    subscriptionCancelledTitle: "Subscription cancelled",
    subscriptionCancelledSummary: "No more charges.",
    subscriptionCancelledAccessUntil: "Access until {date}",
    subscriptionCancelledPlanTokens: "Plan",
    subscriptionCancelledPurchasedTokens: "Purchased",
    tokensExpiring: "Expiring tokens",
    tokensExpiringUntil: "Valid until",
    tokensExpiringUntilUnavailable: "Not available",
    tokensPayg: "PAYG tokens",
    expiringLots: "Expiring lots",
    activeLots: "Active lots",
    missingSubscriptionPlanCode: "Unable to resolve the subscription plan.",
    billingCycle: "Billing cycle",
    monthlyPlans: "Monthly plans",
    monthly: "Monthly",
    annualPlans: "Annual plans",
    annual: "Annual",
    changePlan: "Change plan",
    upgradeSubscription: "Change subscription",
    choosePlan: "Choose plan",
    checkout: "Checkout",
    backToPackages: "Back to plans",
    orderSummary: "Order summary",
    payment: "Payment Details",
    country: "Country",
    searchCountry: "Search your country",
    phone: "Phone",
    phonePlaceholder: "e.g. +525512345678",
    nameOnCard: "Name on card",
    nameOnCardPlaceholder: "e.g. John Smith",
    cardNumber: "Card number",
    cardNumberPlaceholder: "e.g. 4242424242424242",
    expirationDate: "Expiration date",
    cvv: "CVV",
    processing: "Processing...",
    pay: "Pay",
    cardEncrypted: "Your card information is encrypted and never stored.",
    promoLabel: "Have a promo code?",
    promoPlaceholder: "Enter your code",
    promoApply: "Apply",
    promoChecking: "Validating...",
    promoRemove: "Remove",
    promoApplied: "{percent}% discount applied to your plan.",
    promoAppliedCompact: "{percent}% applied",
    promoInvalid: "The promo code is not valid.",
    proBenefitsTitle: "Unlocked benefits",
    confirmed: "Confirmed",
    failed: "Failed",
    pendingConfirmation: "Pending confirmation",
    paymentConfirmed: "Your payment was confirmed and your tokens are now available.",
    purchaseFailed: "Unable to complete your payment.",
    billedMonthly: "Billed every month",
    billedYearly: "Billed every year",
    month: "month",
    year: "year",
    countryRequired: "Country is required.",
    phoneRequired: "Phone is required.",
    phoneFormatInvalid: "Use international format like +525512345678.",
    nameOnCardRequired: "Name on card is required.",
    cardNumber16: "Card number must be 15 digits for Amex or 16 for Visa and Mastercard.",
    expiryMonthInvalid: "Expiry month must be 01-12.",
    expiryYearInvalid: "Expiry year is invalid or in the past.",
    cvv3: "CVC must be 4 digits for Amex or 3 for Visa and Mastercard.",
    subscriptionUpgradeFailed: "Unable to confirm your plan change.",
    subscriptionStartFailed: "Unable to confirm your subscription.",
    requestErrorTitle: "We couldn't complete your request",
    recurringCheckoutPending: "Your selected plan is ready, but recurring checkout wiring is still pending.",
    selectPlanToContinue: "Select a plan to continue.",
    plansKicker: "Plans",
    plansTitle: "Choose your plan",
    plansDescription: "Start for free or unlock everything with Unlimited.",
    freePlanName: "Free",
    freePlanCaption: "Free forever",
    freeFeatureTokens: "240 tokens per month",
    freeFeatureFirstStream: "First stream free, up to 4 hours",
    freeFeatureWatermark: "Clips with watermark",
    freeFeatureNoSocials: "No social network connections",
    freeFeatureNoSchedule: "No post scheduling",
    freeFeatureNoAi: "No AI analysis",
    freeFeatureNoEditor: "No clip editor",
    unlimitedPlanName: "Unlimited",
    unlimitedPlanBadge: "Everything included",
    unlimitedFeatureTokens: "720 tokens per day",
    unlimitedFeatureNoWatermark: "No watermark",
    unlimitedFeatureSocials: "Connect your social networks",
    unlimitedFeatureSchedule: "Schedule your posts",
    unlimitedFeatureAi: "AI stream analysis",
    unlimitedFeatureEditor: "PRO clip editor",
    unlimitedFeatureAnalytics: "Post analytics at 1 and 7 days",
    comingSoon: "Coming soon",
    annualEquivalentPerMonth: "Equivalent to ${amount} USD/month",
    annualSavingsVsMonthly: "Save {percent}% vs monthly",
    paymentGraceWarning: "Your subscription will expire soon because the last charge was not completed. Update your payment method or make sure your card has enough balance before {date} to keep your benefits.",
  },
  tryClips: {
    backAria: "Go back",
    backToSocialNetworksAria: "Back to social networks",
    leaveConfirm: "Are you sure you want to leave? You'll lose the progress of this step.",
    formatTitle: "What kind of content is this?",
    formatHelper: "Choose the type that best describes your content.",
    validatingBadge: "Validating…",
    sourceDownload: {
      eyebrow: "Downloading from {platform}",
      subtitle: "Bringing your video into Clipr…",
      genericTitle: "Your video",
      sourceFallback: "Source",
      downloadSize: "≈ {size} to download",
    },
    downloadStartingTitle: "Starting the download",
    emailTitle: "Verify your email",
    emailSubtitle: "Enter your email and we'll send a quick code to set up your account.",
    emailLabel: "Email",
    emailPlaceholder: "your-email@email.com",
    processing: "Processing...",
    sendCode: "Get my clips",
    legal: {
      acceptPrivacyPrefix: "I accept the ",
      privacyNoticeLink: "Privacy Notice",
      acceptTermsPrefix: "I accept the ",
      termsAndConditionsLink: "Terms and Conditions",
    },
    tryUsedTitle: "This trial is no longer available",
    tryUsedBody: "This email already used its free trial.",
    loginCta: "Sign in",
    helpCta: "Help",
    helpWhatsappMessage: "Hi! I need help at https://app.clipr.tv/create-clips",
    socialThanks: "Thanks! Your clips are on the way",
    socialThanksSubtitle:
      "This takes a few minutes. Keep this tab open while we render your best moments — they'll appear here automatically as soon as they're ready.",
    renderingTipsEyebrow: "Did you know?",
    renderingTips: [
      "Downloading your video at full speed…",
      "Transcribing with AI on GPU…",
      "Finding the most engaging moments…",
      "Rendering vertical, ready to post…",
      "Almost done — this takes others minutes.",
    ],
    greetingHi: "Hi, {name} 👋",
    greetingSub: "Let's find your best moments.",
    preferredNameQuestion: "Your Name",
    preferredNameSub: "What should we call you?",
    preferredNamePlaceholder: "e.g. Bob",
    socialNetworksQuestion: "Where do you post your content?",
    socialNetworksSub: "Tell us your platforms so we can render your clips to match your style.",
    socialUrlsQuestion: "Share your profiles so we can learn your style",
    socialUrlAria: "{network} URL",
    socialPlaceholders: {
      instagram: "https://www.instagram.com/your_username/",
      facebook: "https://www.facebook.com/your.page/",
      x: "https://x.com/your_username",
      tiktok: "https://www.tiktok.com/@your_username",
      youtube: "https://www.youtube.com/@your_channel",
    },
    socialEmptyCopy: "Select at least one social network to complete this step.",
    continue: "Continue",
    saving: "Saving...",
    submitAnswers: "See my clips",
    processingVideoTitle: "Processing your video...",
    processingFailedSubtitle:
      "We could not complete the processing. Check the URL and try again.",
    extraClipsLabel: "more clips",
    extraClipsHint: "Unlock to watch",
    extraClipsScoreHintOne: "1 with good score",
    extraClipsScoreHintMany: "{count} with good score",
    viewPlans: "View plans",
    resultsEyebrow: "Clips ready",
    resultsTitle: "Your clips are ready",
    resultsTitleNamed: "Your clips are ready, {name}",
    resultsSubtitle: "Unlock all your clips.",
    results: {
      speedFlex: "Your {duration} video → these clips, in seconds",
    },
    resultExpiry: {
      topTitle: "Your clips are available for a limited time.",
      topSubtitle: "{time} left",
      bottomTitle: "The clock is ticking.",
      bottomSubtitle: "Download them before your access expires: {time}",
    },
    unlockAllCta: "Unlock all my clips",
    unlockAllNote: "No watermark · full length · ready to post",
    accountExistsTitle: "Sign in and choose a plan",
    accountExistsBody:
      "This email already has an account. Sign in and choose a plan to keep rendering.",
    alreadySubscribedTitle: "You already have Clipr",
    alreadySubscribedBody:
      "Your account already has an active subscription. We'll take you to the app to keep creating clips.",
    alreadySubscribedCta: "Go to the app",
    accountCreatedBadge: "Payment confirmed",
    accountCreatedTitle: "Thank you for your payment",
    accountCreatedBody: "Your Premium account is ready. Save your password before continuing.",
    accountCreatedPlanLabel: "Plan purchased",
    accountCreatedPasswordLabel: "Your login password",
    accountCreatedPasswordCopy: "Copy",
    accountCreatedPasswordCopied: "Copied",
    accountCreatedPasswordHint: "Save it somewhere safe. You will need it to sign in.",
    accountCreatedCta: "Go to Clipr Premium",
    accountCreatedFreeBadge: "Account created",
    accountCreatedFreeTitle: "Your free plan is ready",
    accountCreatedFreeCta: "Go to Clipr",
    subscriptionPendingTitle: "Confirming your subscription",
    subscriptionPendingBody:
      "We are validating the payment and enabling your tokens. This can take a few seconds.",
    subscriptionPendingRefreshCta: "Refresh status",
    orSeparator: " or ",
    contentTypes: {
      gameplay: {
        label: "Split screen",
        description: "Your camera on top, content below.",
      },
      podcast: {
        label: "Podcast",
        description: "Several people on screen.",
      },
      irl: {
        label: "Full video",
        description: "Everything stays visible, blurred background.",
      },
      justChatting: {
        label: "Standard",
        description: "One single shot, centered.",
      },
    },
    loader: {
      rendering: "Rendering",
      downloading: "Downloading...",
      speedEyebrow: "Processing at full speed",
      hintDownloading: "",
      hintRendering: "",
      eta: {
        minUnit: "min",
        minutesRemaining: "min left",
        oneMinuteAria: "1 min",
        minutesRemainingAria: "{minutes} min left",
      },
    },
    downloadAnimation: {
      platformDetected: "Platform detected",
      failed: "Process failed",
      validating: "Validating",
      preparing: "Preparing",
      confirmingUrl: "Confirming URL",
    },
    verification: {
      title: "Check your email",
      subtitle: "Enter the 6-digit code we just sent to {email}.",
      codeLabel: "Verification code",
      codeGridAria: "Verification code",
      verifying: "Verifying...",
      resendCode: "Resend code",
      resending: "Resending...",
      resendCountdown: "Resend code in {seconds}s",
    },
    clipCard: {
      free: "Free",
      scoreTitle: "Clip score",
      playClipAria: "Play clip",
      unlockClipAria: "Unlock clip",
      unlockFull: "Unlock to watch it fully",
      ready: "It is ready",
    },
    urlForm: {
      heroTitle: "Turn your stream into viral clips",
      heroSubtitle:
        'Paste your video link and get clips ready to post <span class="try-url-hero-subtitle-accent">free</span>!',
      heroStep1: "Paste your link",
      heroStep2: "Pick your format",
      heroStep3: "Get your clips",
      urlLabel: "Video URL",
      autodetected: "Auto-detected",
      unknownPlatform: "Unknown",
      validatingInfo: "Validating info",
      drivePermissionsTitle: "Public permissions required",
      drivePermissionsBody:
        'Make sure the Google Drive file is public: "Anyone with the link" and downloads are allowed.',
      facebookReelHorizontalTitle: "Horizontal format required",
      facebookReelHorizontalBody: "If you use Facebook Reels, make sure your Reel is in horizontal format (16:9).",
      errors: {
        unrecognizedUrlTitle: "Unrecognized URL",
        unrecognizedUrlMessage:
          "Unrecognized URL. Only Twitch, YouTube, Facebook, Kick, and public Google Drive links are supported.",
        invalidTwitchTitle: "Invalid Twitch format",
        invalidYoutubeTitle: "Invalid YouTube format",
        invalidFacebookTitle: "Invalid Facebook format",
        invalidKickTitle: "Invalid Kick format",
        invalidGoogleDriveTitle: "Invalid Google Drive format",
        invalidUrlTitle: "Invalid URL format",
        twitchFormat: "Only VOD URLs are supported. Format: https://www.twitch.tv/videos/<digits>",
        youtubeFormat: "Invalid YouTube URL format. Use /watch?v=..., /live/..., or youtu.be/...",
        facebookFormat: "Invalid Facebook URL format. Use .../videos/<id>",
        kickFormat: "Invalid Kick URL format. Use https://kick.com/<channel>/videos/<id>",
        googleDriveFormat:
          "Invalid Google Drive URL format. Use a public file link: /file/d/<id>/... or /open?id=<id>.",
        invalidUrlMessage: "Invalid URL format.",
      },
    },
    paywall: {
      noPlans: "No plans are available right now.",
      availablePlans: "Available plans",
      heroEyebrow: "You just saw it",
      heroSpeedTitle: "Your {duration} video → clips ready",
      heroSpeedSub:
        "We downloaded and edited it in seconds. Others take minutes just to download it.",
      yourClipsTitle: "Your {count} clips are ready",
      yourClipsSubtitle: "{unlocked} unlocked · {count} waiting for you",
      yourClipsSubtitleAll: "{unlocked} ready for you",
      unlockHeadline: "Unlock your other {count} clips",
      unlockHeadlineAll: "Unlock all your clips",
      valueUnlimited: "Up to 12 hours of video daily — among the best in the market",
      valueKeepClips: "Keep the clips we already made for you",
      valueCancel: "Cancel anytime, no hassle",
      expiryCountdown: "Your clips are deleted in {time}",
      socialProofTitle: "Real clips made with Clipr",
      popularBadge: "Most popular",
      bestValueBadge: "Best value",
      startFreePlanBadge: "Free",
      startFreePlanName: "Start Free",
      startFreePlanDescription: "Create your free account and start from Clipr.",
      startFreePlanCaption: "No card, no cost",
      startFreePlanTrial: "Free plan to get started",
      offerTokensFree: "240 tokens per month",
      offerTokensUnlimited: "720 tokens per day",
      tokenEquivalencyHint: "1 token = 1 minute of rendering",
      freePlanProDisclaimer: "No PREMIUM features",
      freePlanWatermarkDisclaimer: "Clips with watermark",
      startFreeBenefitAccountTitle: "Account ready instantly",
      startFreeBenefitAccountBody: "We take you straight to Clipr with your password.",
      startFreeBenefitUpgradeTitle: "Upgrade to Unlimited later",
      startFreeBenefitUpgradeBody: "Unlock unlimited clips and PRO features whenever you want.",
      freePriceLabel: "Free",
      offerDiscount: "-{percent}%",
      playClipAria: "Play clip",
      lockedClipsOverflowAria: "{count} more clips waiting for you — unlock them",
      unlimitedClips: "Unlimited clips",
      billedMonthly: "Billed monthly",
      billedAnnually: "${amount} {currency} billed once a year",
      perMonthShort: "/mo",
      choosePlan: "Choose plan",
      orderSummary: "Order summary",
      proBenefitsTitle: "What you unlock with Premium",
      demoClipsEyebrow: "Real clips",
      demoClipsTitle: "See publish-ready results",
      demoClipsViews: "{count} views",
      demoClipsPlayAria: "Play {platform} clip with {views} views",
      demoClipsPauseAria: "Pause {platform} clip with {views} views",
      paymentDetails: "Payment details",
      country: "Country",
      searchCountry: "Search country...",
      clearCountryAria: "Clear selected country",
      phone: "Phone (optional)",
      nameOnCard: "Name on card",
      nameOnCardPlaceholder: "Full name",
      cardNumber: "Card number",
      cardNumberPlaceholder: "e.g. 4242424242424242",
      expiration: "Expiration",
      cvc: "CVC",
      processingPayment: "Processing payment...",
      payAndUnlock: "Pay and unlock",
      choosePlanTitle: "Choose your plan",
      choosePlanSub: "Instant access to all your clips — cancel anytime",
      checkoutDueToday: "Due today: ${amount} {currency}",
      checkoutRenewsMonthly: "Renews at ${amount} {currency}/mo. Cancel anytime.",
      checkoutRenewsAnnually: "Renews at ${amount} {currency}/year — that's ${monthly}/mo. Cancel anytime.",
      checkoutKeepClips: "Keep the clips we already made for you",
      cardEncrypted: "Your card information is encrypted and never stored.",
      promoLabel: "Have a promo code?",
      promoPlaceholder: "Enter your code",
      promoApply: "Apply",
      promoChecking: "Validating...",
      promoRemove: "Remove",
      promoApplied: "{percent}% discount applied to your plan.",
      promoAppliedCompact: "{percent}% applied",
      promoInvalid: "The promo code is not valid.",
      promoSessionError: "Invalid session to validate the code.",
      benefits: {
        perfectClipTitle: "Pro video editor",
        perfectClipBody: "Reframe, trim and fine-tune every clip.",
        brandEndTitle: "Connect your socials",
        brandEndBody: "Publish straight to TikTok, Instagram and YouTube.",
        noWatermarkTitle: "No watermark",
        noWatermarkBody: "Clean clips, ready to post.",
        publishTitle: "Schedule your posts",
        publishBody: "Schedule and auto-post.",
        speedTitle: "Unmatched speed",
        speedBody: "Turns hours of video into clips in seconds.",
      },
      errors: {
        countryRequired: "Country is required.",
        phoneRequired: "Phone is required.",
        phoneFormat: "Use the format +525512345678.",
        nameOnCardRequired: "Name on card is required.",
        cardNumberLength: "Card number must have 15 digits for Amex or 16 for Visa and Mastercard.",
        testCardLocalOnly: "Test cards are only allowed in local development.",
        expiryMonth: "Expiration month must be 01-12.",
        expiryYear: "Expiration year is invalid or expired.",
        cvcLength: "CVC must have {count} digits.",
      },
    },
    errors: {
      selectSocialNetwork: "Select at least one social network.",
      preferredNameRequired: "Tell us what you would like us to call you.",
      socialProfileRequired: "Enter your {network} URL.",
      socialUrlNoSpaces: "The URL must not contain spaces.",
      socialUrlInvalid: "Enter a valid URL (include https://).",
      socialUrlHostRequired: "The URL must belong to {hosts}.",
      socialSessionMissing: "There is no active session to save answers.",
      correctSocialUrls: "Fix the URLs before continuing.",
      socialSaveError: "Could not save your answers.",
      metadataServiceConfig:
        "The backend metadata service is not configured for YouTube/Kick. Add CLIPR_YOUTUBE_METADATA_API_KEY to the backend .env and restart it.",
      metadataValidation: "Could not validate the stream URL.",
      durationLimit: "This stream is over the free 4-hour limit. Paste a shorter stream to continue.",
      durationRequired: "We could not validate the stream duration. Use a URL with available duration.",
      verticalNotSupported: "This video is vertical. We only support horizontal videos (16:9).",
      selectFormat: "Select a format before continuing.",
      emailRequired: "Enter an email to continue.",
      emailInvalid: "That email doesn't look right. Check it and try again.",
      privacyNoticeRequired: "You must accept the Privacy Notice to continue.",
      termsAndConditionsRequired: "You must accept the Terms and Conditions to continue.",
      tryStart: "Could not start the trial.",
      networkError: "We could not reach the server. Check your connection and try again.",
      resendCode: "Could not resend the code.",
      invalidVerificationResponse: "Invalid server response for verification.",
      invalidTrackingResponse: "Invalid server response for try tracking.",
      invalidVerificationSession: "Invalid verification session. Try again.",
      verifyCode: "Could not verify the code.",
      statusLoad: "Could not load the trial status.",
      subscriptionStatusLoad:
        "We could not validate your subscription status. We will keep retrying automatically.",
      subscriptionNotConfirmed:
        "We could not confirm your subscription payment. Please try again.",
      unlockSession: "There is no valid session to unlock.",
      checkout: "Could not complete the payment.",
      generatedPasswordMissing: "The payment was confirmed, but the server did not return the password. Restart the backend and try again.",
    },
  },
  onboarding: {
    stepOf: "Step {n} of {total}",
    back: "Back",
    next: "Continue",
    finish: "Finish",
    skip: "Skip",
    title: "Complete your account",
    subtitle: "Before you continue, add your phone number in international format.",
    phoneLabel: "Phone number",
    phonePlaceholder: "+525512345678",
    phoneHint: "Use full international format, for example +525512345678.",
    phonePromoHint: "Add your phone number to complete your profile.",
    ageRangeLabel: "What is your age range?",
    editingProcessLabel: "How do you describe your current editing process?",
    socialFrequencyLabel: "What is your current posting frequency on social media?",
    primaryGoalLabel: "What do you want most?",
    ageRangeOptions: {
      "18_24": "18–24",
      "25_34": "25–34",
      "35_44": "35–44",
      "45_54": "45–54",
      "55_64": "55–64",
      "65_plus": "65+",
    },
    editingProcessOptions: {
      self_editing: "I do it myself.",
      editor_or_freelancer: "I have an editor or freelancer.",
      internal_team: "I have an in-house team.",
      not_editing_videos: "I am not editing videos right now.",
    },
    socialFrequencyOptions: {
      post_daily: "I post daily.",
      post_once_or_twice_weekly: "I post once or twice a week.",
      post_randomly: "I post randomly when I have time.",
      have_material_but_rarely_post: "I have material recorded but I rarely get around to posting it.",
    },
    primaryGoalOptions: {
      find_viral_moments: "Find viral moments",
      save_editing_time: "Save editing time",
      post_more_consistently: "Post more consistently",
      auto_publish_to_socials: "Auto-publish to socials",
    },
    submitting: "Saving...",
  },
  makeClips: {
    sourceModeLabel: "Video source",
    uploadMp4Toggle: "Upload MP4",
    uploadMp4Label: "MP4 file",
    uploadMp4DropTitle: "Drop your MP4 or select it",
    uploadMp4DropHint: "Click to browse for the file",
    uploadMp4HeroSubtitle:
      'Upload your MP4 and get clips ready to post <span class="try-url-hero-subtitle-accent">in minutes</span>!',
    uploadMp4Requirements: "Horizontal MP4, up to 1080p, 12 hours, and 100 GiB.",
    uploadPlanRequired: "MP4 upload requires the Unlimited plan.",
    uploadAlreadyActive: "You already have an active MP4 upload.",
    uploadInvalidMp4: "Select a valid MP4 file.",
    uploadVerticalNotSupported: "This video is vertical. Only horizontal MP4 files are supported.",
    uploadResolutionExceeded: "The resolution exceeds 1080p.",
    uploadDurationExceeded: "The video exceeds the 12-hour limit.",
    uploadSizeExceeded: "The file exceeds the 100 GiB limit.",
    uploadIncomplete: "The upload is incomplete. Please try again.",
    uploadWaiting: "The upload is still waiting for availability.",
    uploadFailed: "The MP4 could not be uploaded.",
    uploadReserving: "Reserving upload...",
    uploadUploading: "Uploading MP4...",
    uploadCompleting: "Completing upload...",
    uploadComplete: "Upload complete.",
    uploadQueuePosition: "Queue position: {position}",
    enableSubtitles: "Add subtitles",
    enableSubtitlesDescription: "Generate automatic subtitles on your clips.",
    subtitlesStatusOn: "Enabled",
    subtitlesStatusOff: "Disabled",
    flowStep2Chip: "Step 2 of 3",
    flowStep3Chip: "Step 3 of 3",
    flowConfigureTitle: "Choose video type",
    flowConfigureSubtitle: "Sets how your clips are laid out.",
    flowConfirmTitle: "Review and confirm",
    flowConfirmSubtitle: "Confirm the cost and send to the queue.",
    flowBack: "Back",
    flowContinue: "Continue",
    flowChange: "Change",
    flowVideoDetected: "Video detected",
    flowDurationHint: "Duration: {duration}",
    flowTrimHint: "Leave it empty to process the full VOD, or mark on the timeline only the moments you want.",
    flowNoDurationTitle: "We couldn't get the video duration",
    flowNoDurationBody: "Define your segments manually with the time fields to calculate the cost.",
    flowNeedSegmentsForCost: "Add at least one segment so we can calculate the cost of this video.",
    flowSelectTypeHint: "Select a type to continue.",
    flowQueuedSuccess: "Your video is in the queue! Check your collections to track progress.",
    flowQueuedSuccessAdmin: "Video queued. You can add another one right away.",
    flowValidationErrorTitle: "We couldn't validate your video",
    flowAutoValidateHint: "We'll validate your video automatically. Press Enter if it doesn't advance.",
    flowSubmitError: "We couldn't queue your video. Please try again.",
    flowNoSpaceForSegment: "There's no space left at the end of the video for another segment.",
    flowValidationTimeout: "Validation is taking too long. Please try again.",
    flowReassignFailed: "The video was queued, but it could not be assigned to the selected user.",
    timelineTrimLabel: "Trim timeline",
    timelineEmptyHint: "Click on the timeline to add a segment",
    timelineHelp: "Drag the edges to adjust start and end, drag the block to move it, or click an empty spot to add another segment.",
    addAnotherClip: "Add another clip",
    urlHeroSubtitle:
      'Paste your video link and get clips ready to post <span class="try-url-hero-subtitle-accent">in minutes</span>!',
    firstFreeStreamBannerChip: "Welcome offer",
    firstFreeStreamBannerTitle: "Your first stream is free, up to 4 hours",
    firstFreeStreamBannerSubtitle:
      "You have 24 hours from account creation to use it.",
    firstFreeStreamCountdownLabel: "Take advantage of the offer, time remaining",
    firstFreeStreamBannerCta: "Create my first stream",
    firstFreeStreamCost: "Free",
    firstFreeStreamCostHint: "Included in your welcome offer.",
    firstFreeStreamDurationLimit: "Your first free stream covers up to 4 hours. Trim the VOD to continue.",
    unlimitedDailyStreamLimit: "The daily limit is 12 hours of video. You can trim the stream to process it. Sorry for the inconvenience.",
    enterVideoUrl: "Enter video URL",
    autodetected: "Autodetected",
    supportedFormats: "Supported formats: Twitch, YouTube, Facebook, Kick, Google Drive (public).",
    videoTypeLabel: "Video type",
    videoTypeAuto: "Auto",
    videoTypeIrl: "Full video",
    videoTypeGameplay: "Split screen",
    videoTypeJustChatting: "Standard",
    videoTypeStream: "Stream",
    videoTypePodcast: "Podcast",
    videoTypeModalHelper: "Choose the format before creating the VOD so the render uses the right layout from the start.",
    videoTypeGameplayDescription: "Your camera on top, content below.",
    videoTypeJustChattingDescription: "One single shot, centered.",
    videoTypeIrlDescription: "Everything stays visible, blurred background.",
    videoTypePodcastDescription: "Several people on screen.",
    videoTypeCenterDescription: "Centered vertical.",
    selectVideoTypeBeforeCreate: "Select a video type before creating clips.",
    trimVideoTitle: "Adjust video range",
    trimVideoHelper: "Adjust the range on the timeline.",
    videoGeneralContextHelper: "Add details that help the AI understand the scene",
    defineSegments: "Define segments",
    optionalSegments: "Optional segments",
    optionalSegmentsHint: "Leave this empty to process the full VOD. Add segments only if you want specific moments.",
    optionalSegmentsPrompt: "Only need specific moments?",
    showOptionalSegments: "Add optional segments",
    hideOptionalSegments: "Hide",
    addSegment: "Add segment",
    fullVodDefault: "Full VOD",
    fullVodHint: "We will process the full video if you do not define segments.",
    segmentsSequenceHint: "Segments are processed in order and cannot overlap.",
    totalCutTime: "Total trimmed time",
    processingRequest: "Processing your request...",
    noEnoughTokens: "You do not have enough tokens for this stream",
    enterValidUrlFirst: "Enter a valid video URL first",
    fixSegmentsBeforeSubmit: "Fix segment timings before submitting",
    selectAssigneeFirst: "You must select a user in Assign before creating clips",
    startCreateClips: "Start creating clips from your video",
    reviewBeforeCreate: "Review before creating",
    reviewBeforeCreateHint: "Confirm the cost, duration, and segments before sending this to the queue.",
    reviewClips: "Review clips",
    getClips: "Get clips",
    reviewClipsTitle: "Review your video and segments before creating clips.",
    inQueue: "In queue...",
    queueingClips: "Queueing...",
    createClips: "Create clips",
    insufficientTokens: "You do not have enough tokens",
    need: "need",
    have: "have",
    buyTokens: "Buy tokens",
    autoProcessHint: "Your clips will be processed automatically. Check your collections to see progress.",
    clipLabel: "Clip",
    segmentLabel: "Segment",
    segmentNamePlaceholder: "Optional label",
    start: "START",
    end: "END",
    confirmCreateTitle: "Confirm clip creation",
    confirmCreateSubtitle: "Review video information before sending to queue",
    confirmAndCreate: "Get clips",
    loadingVodInfo: "Loading VOD information...",
    loadingVideoInfo: "Loading video information...",
    assignedUser: "Assigned user",
    unassignedCurrentUser: "Unassigned (will be created for your current user)",
    tokensSummary: "Token summary",
    changeVideoType: "Change",
    dailyRenewal: "Daily renewal",
    tokenMinuteRate: "1 token = 1 minute",
    unlimitedTokensDailyHint: "Your tokens renew daily.",
    tokenSingular: "token",
    tokenPlural: "tokens",
    vodsToProcess: "VODs to process",
    totalTime: "Total time",
    processingTime: "Time to process",
    processingDurationHint: "{duration} will be processed",
    totalEstimatedCost: "Estimated total cost",
    estimatedCost: "Estimated cost",
    tokensLabel: "In tokens",
    yourBalance: "Your balance",
    remainingAfter: "Remaining",
    costCalculatedWithSegments: "Cost calculated using your selected segments.",
    costCalculatedWithFullVod: "Cost calculated using the total VOD duration.",
    notEnoughTokensForVods: "You do not have enough tokens to process these VODs.",
    notEnoughTokensForVod: "You do not have enough tokens to process this VOD.",
    insufficientTokensWithClipSuggestion:
      "You do not have enough tokens. You can buy more tokens or trim a segment of your stream using the clipping tool below \"Enter video url\".",
    selectedSegments: "Selected segments",
    noSegmentsFullVod: "No segments defined. The full VOD will be processed.",
    videoGeneralContext: "General video context",
    enableVideoGeneralContext: "Enable context",
    videoGeneralContextPlaceholder: "Add general context for this video (optional)",
    assignCreateTitle: "Assign clip creation",
    assignCreateSubtitle: "Select the user this VOD will be assigned to when created.",
    assignClipCreationUser: "Clip creation user",
    noAssignableUsers: "No users available with Twitch access.",
    close: "Close",
    scheduleSubscriptionPromptTitleNoSubscription: "Upgrade to Unlimited",
    scheduleSubscriptionPromptBodyNoSubscription:
      "With Unlimited you get 720 tokens per day, can edit your clips, personalize the end card, and remove the watermark.",
    scheduleSubscriptionPromptTitleWithSubscription: "Your Unlimited subscription",
    scheduleSubscriptionPromptBodyWithSubscription:
      "Your account already has an active subscription with daily tokens and clips without a watermark.",
    scheduleSubscriptionPromptSubscribeCta: "Subscribe",
    scheduleSubscriptionPromptContinueCta: "Continue anyway",
    scheduleSubscriptionPromptImageAlt: "Watermark preview on a generated clip",
    scheduleSubscriptionPromptImageCaption:
      "With Unlimited you can edit your clips, remove the watermark, and close every video with a personalized end card.",
    scheduleSubscriptionPromptBenefitTokens: "720 tokens per day to publish clips without friction.",
    scheduleSubscriptionPromptBenefitEditor:
      "Edit your clips: adjust the start and end, change the video type, and rerender without leaving your flow.",
    scheduleSubscriptionPromptBenefitEndCard:
      "Add an end card with your @ and a custom image so every clip closes on your brand.",
    scheduleSubscriptionPromptBenefitWatermark: "Remove the watermark and elevate your brand perception.",
    scheduleSubscriptionPromptBenefitScale: "Connect your social networks and schedule your posts to accelerate your growth.",
    scheduleSubscriptionPromptBenefitCustomLogo:
      "Add your own logo on the end card—every clip closes on your brand, looks more professional, and helps viewers remember you.",
    scheduleSubscriptionPromptProof:
      "Activate your subscription in under a minute and keep scheduling without leaving your flow.",
    streamSegments: "Stream segments",
    connectedAccounts: "Networks",
    authRequired: "You must sign in.",
    resolveUserIdError: "Could not resolve the user's user_id.",
    assigneeUserIdNotFound: "Selected user's user_id was not found.",
    reassignJobError: "Could not reassign the job.",
    assignUserBeforeCreate: "You must assign a user before creating clips.",
    bulkAddAtLeastOneValidUrl: "Add at least one valid URL to create clips.",
    enterValidUrl: "You must enter a valid URL.",
    urlOnlyVodsTwitch: "Only VOD URLs are allowed. Format: https://www.twitch.tv/videos/<digits>",
    invalidYoutubeUrlFormat: "Invalid YouTube URL format. Use /watch?v=..., /live/... or youtu.be/...",
    invalidFacebookUrlFormat: "Invalid Facebook URL format. Use .../videos/<id>",
    invalidKickUrlFormat: "Invalid Kick URL format. Use https://kick.com/<channel>/videos/<id>",
    invalidGoogleDriveUrlFormat:
      "Invalid Google Drive URL format. Use a public file link: /file/d/<id>/... or /open?id=<id>.",
    invalidTwitchUrlWithExample: "Invalid Twitch format. Valid example: {example}",
    invalidYoutubeUrlWithExample: "Invalid YouTube format. Valid example: {example}",
    invalidFacebookUrlWithExample: "Invalid Facebook format. Valid example: {example}",
    invalidKickUrlWithExample: "Invalid Kick format. Valid example: {example}",
    invalidGoogleDriveUrlWithExample: "Invalid Google Drive format. Valid example: {example}",
    unrecognizedUrlWithExamples:
      "Unrecognized URL. Accepted formats (examples): YouTube: {youtube} | Twitch: {twitch} | Kick: {kicks} | Facebook: {facebook} | Drive: {drive}",
    googleDrivePublicAccessHint:
      "For Google Drive, the file must be shared as \"Anyone with the link\" and allow downloads.",
    invalidUrlFormat: "Invalid URL format.",
    segmentTimesRequired: "Each segment must have valid start and end times.",
    segmentStartTimeInvalid: "Each segment must have a valid start time.",
    segmentEndTimeInvalid: "Each segment must have a valid end time.",
    segmentEndAfterStart: "Each segment must end after it starts.",
    segmentStartAfterPrevious: "Start must be after {previousEnd} (minimum: {minimumStart})",
    segmentEndMustBeAfterStart: "End must be greater than start",
    segmentsSequentialNoOverlap: "Segments must be sequential and cannot overlap.",
    unknownSource: "Unknown",
    unrecognizedUrlOnlySupported: "Unrecognized URL. Only Twitch, YouTube, Facebook, Kick, and public Google Drive are supported.",
    queueJobError: "Error queueing the job",
    clipQueuedSuccess: "Clip queued successfully.",
    clipQueueError: "Could not queue the clip.",
    noValidUrlsToQueue: "There are no valid URLs to queue.",
    batchQueueError: "Error queueing clip batch",
    clipQueuedButReassignFailed: "The clip was queued, but it could not be reassigned.",
    clipQueueItemError: "Could not queue this clip.",
    bulkQueueAllSuccess: "{count} clip{suffix} queued successfully.",
    bulkQueuePartialError: "{success} clip{suffix} queued and {failed} failed.",
    bulkQueueNone: "No clips could be queued. Check each card for errors.",
    detectPlatformError: "Could not detect the video's platform.",
    untitled: "Untitled",
    metadataFetchError: "Could not fetch metadata.",
    metadataVerticalNotSupported: "This video is vertical. We only support horizontal videos (16:9).",
    metadataSourceAccessDenied:
      "We could not access this video. Check that it is public and try again.",
    metadataSourceUnavailable:
      "This video is unavailable, private, or no longer exists.",
    metadataServiceUnavailable:
      "Video import is being updated. Please try again in a few minutes.",
    metadataExtractionFailed:
      "We could not read this video's information. Please try again.",
    metadataRestrictedFullVod:
      "Could not fetch YouTube metadata to calculate the full VOD cost. Configure valid yt-dlp cookies in the backend or define segments manually.",
    googleDriveAccessError:
      "Google Drive blocked access to the file because of its permissions. Change the file permissions to \"Anyone with the link\" and make sure downloads are allowed.",
    googleDriveAccessErrorWithIndex:
      "Google Drive blocked access to the file for clip #{index} because of its permissions. Change the file permissions to \"Anyone with the link\" and make sure downloads are allowed.",
    clipUrlInvalidWithIndex: "Clip #{index} URL is invalid.",
    clipMetadataFetchErrorWithIndex: "Could not fetch metadata for clip #{index}.",
    clipMetadataRestrictedWithIndex:
      "Could not fetch YouTube metadata for clip #{index}. Configure valid yt-dlp cookies in the backend or define segments manually to calculate the cost.",
    bulkMetadataFetchError: "Could not fetch VOD metadata.",
  },
  schedulePost: {
    processedStreams: "Processed streams",
    processedClips: "Processed clips",
    backToProcessedClips: "Back to browser",
    streamsGreetingTitle: "Hi, {name}! These are your processed streams and videos",
    streamsGreetingEmptyTitle: "Hi, {name}! Your streams will show up here",
    streamsGreetingFallbackName: "creator",
    streamsBrowserHint: "Click your jobs to see your processed clips",
    streamsGreetingEmptyHint: "Your streams will appear here once you process them. Render your first stream to start scheduling clips.",
    streamsGreetingEmptyHintEmbedded: "When you process your first stream, it will appear here. Use the form above to render your first VOD.",
    stream: "stream",
    streams: "streams",
    streamUser: "User (stream)",
    demoAssetsError: "Could not load demo VOD.",
    demoVodTitle: "Demo VOD",
    demoVodActionBlocked: "This is a demo VOD, this action is not available",
    demoBadge: "DEMO",
    needRenderedVideos: "Rendered videos are required to schedule posts.",
    noStreamsFound: "No streams were found for this period.",
    noStreamsFoundHint: "Your clips will appear here when they are available to schedule.",
    noCollectionsReady: "No ready clip collections found",
    collectionsReadyHint: "Collections with clips ready to post will appear here",
    noStreamMatchFilter: "No stream matches the user filter.",
    clip: "clip",
    readyToPost: "ready to post",
    statusPillReadyToPost: "ready to post",
    statusPillScheduled: "scheduled",
    statusPillPosted: "posted",
    statusPillPostFailed: "post failed",
    clips: "Clips",
    job: "Job",
    selectStreamAbove: "Select a stream above to view its clips.",
    clipId: "ID",
    duration: "Duration",
    range: "Range",
    timeRange: "Time range",
    schedule: "Schedule",
    publish: "Publish",
    clipActions: "Clip actions",
    clipActionsShort: "Actions",
    viewClips: "View clips",
    of: "of",
    clipsPage: "Page",
    backToVods: "Back to VODs",
    clipDetails: "Clip details",
    noPreviewAvailable: "Preview is not available",
    downloading: "Downloading...",
    deleting: "Deleting...",
    noReadyClipsInCollection: "No ready clips in this collection.",
    calendarTimeline: "Calendar timeline",
    fullCalendar: "Full calendar",
    noVideoYet: "no video yet",
    noClipYet: "no clip yet",
    noClipsFound: "no clips scheduled",
    scheduleClip: "Schedule clip",
    previousClip: "Previous clip",
    nextClip: "Next clip",
    reviewBeforeDate: "Review platforms and fields before choosing publication date and time.",
    generalSettings: "Details",
    title: "Title",
    titleAllPlatforms: "Title used across all platforms",
    description: "Description",
    descriptionPlaceholder: "Subtitle / description",
    options: "Options",
    asyncUpload: "Asynchronous upload",
    platforms: "Platforms",
    platformStripHint:
      "Turn the switch on to publish to that network. Tap the logo to open that platform's settings.",
    networkToggleHint: "Select where this clip will be published.",
    platformSwitchOn: "Enable",
    platformSwitchOff: "Disable",
    platformEnableByTap: "Tap to enable",
    platformDisableByTap: "Tap to disable",
    publishEnabled: "Selected",
    publishDisabled: "Not selected",
    platformUnavailable: "Not selected",
    platformDisconnected: "Not connected",
    openPlatformSettingsA11y: "Open settings for",
    connectSocialPromptTitle: "Connect your social networks",
    connectSocialPromptSubtitle: "You need at least one connected network to schedule clips.",
    connectSocialPromptBody:
      "Go to Settings to connect your social networks and come back to schedule this clip.",
    connectSocialPromptContinue: "Continue",
    returnToSchedule: "Back to scheduling",
    openingConnection: "Opening connection...",
    openningconnection: "Opening connection...",
    saving: "Saving...",
    scheduling: "Scheduling...",
    saveAndSchedule: "Save and schedule",
    saveScheduledChanges: "Save changes",
    editScheduledMetadata: "Edit schedule",
    chooseDateTime: "Date and time",
    stepCurrent: "Current step",
    stepDone: "Completed",
    stepNext: "Next",
    stepPending: "Pending",
    confirmPublishWhen: "Confirm when the clip will be published.",
    scheduleQuestionPrefix: "Schedule",
    forThe: "for",
    forSelectedDate: "for the selected date?",
    selectDateBelow: "Select a date below.",
    timezone: "Timezone",
    selectTimezone: "Select timezone",
    selectTimezoneHint: "Please select a timezone",
    postingDateLabel: "Posting timeline",
    postingTime: "Posting time",
    hour: "Hour",
    minute: "Minute",
    selectPostingTimeHint: "Please select a posting time",
    manageScheduledSubtitle: "Details and actions for this post.",
    manageScheduledBody: "You are managing this clip's scheduled post. Details are shown below.",
    deleteStepOne: "This clip will no longer be available in scheduling.",
    deleteReviewHint: "Review the clip before confirming; you can cancel with the button below.",
    deleteStepTwoWarning: "If you continue, the clip will be deleted and will not appear in this view again.",
    period1d: "1 day",
    period3d: "3 days",
    period7d: "7 days",
    scopeAllUsers: "All users",
    scopeMyClips: "Only my clips",
    scopeMyUsers: "Only my users",
    errorSelectDate: "Please select a date",
    errorSelectPostingTime: "Please select a posting time",
    errorSelectTimezone: "Please select a timezone",
    errorLoginToSchedule: "You must sign in to schedule a clip.",
    errorInvalidDate: "Invalid date",
    errorTimeTooClose: "Selected time is too close. Pick a slightly later time.",
    errorChooseFutureTime: "Please choose a future time",
    errorScheduleClip: "Error scheduling clip",
    errorGenerateConnectionLink: "Could not generate connection link",
    errorLoginToCancelUpload: "You must sign in to cancel upload.",
    scheduledAt: "Scheduled",
    errorNoClipSelected: "No clip selected",
    errorNoTitle: "Title is required.",
    errorNoConnectedPlatforms:
      "You do not have social networks connected to schedule this clip. Connect at least one from your profile.",
    errorLoginToSaveMetadata: "You must sign in to save metadata.",
    errorOpenSettings: "Could not open settings.",
    errorOpenSocialConnection: "Could not open social connection.",
    errorUpdateMetadata: "Could not update clip metadata",
    metadataSavedFor: "Metadata saved for",
    errorSavingMetadata: "Error saving metadata.",
    instagramSettings: "Instagram settings",
    tiktokSettings: "TikTok settings",
    youtubeSettings: "YouTube settings",
    facebookSettings: "Facebook settings",
    facebookPublishHint:
      "Videos will be published to the Facebook Page linked in your profile.",
    facebookPageId: "Facebook page",
    facebookPageSelectPlaceholder: "Select a page",
    loadingFacebookPages: "Loading Facebook pages...",
    facebookPagesLoadError: "Could not load your Facebook pages.",
    facebookPagesEmpty: "No Facebook pages available for this account.",
    facebookPageUnknownName: "Saved page",
    errorFacebookPageIdRequired: "You must select a Facebook Page before scheduling this clip.",
    xSettings: "X (Twitter) settings",
    xPublishHint:
      "Posts will be sent to the X (Twitter) account linked in your profile.",
    selectPlatformToPreview: "No social networks are selected",
    likesLabel: "Likes",
    commentsLabel: "Comments",
    shareLabel: "Share",
    tags: "Tags",
    tagsPlaceholder: "tag1, tag2",
    tagsCommaHint: "Comma-separated tags",
    tagsDuplicate: "This hashtag already exists.",
    selectedNetwork: "Selected network",
    defaultLanguage: "Default language",
    iso639Hint: "ISO 639-1 code",
    selectFacebookForSettings:
      "Select Facebook to configure platform-specific metadata in this modal.",
    selectAtLeastOnePlatform: "Select at least one platform in General settings to configure platform-specific metadata.",
    loadJobsError: "Could not load jobs.",
    loadClipsError: "Could not load clips.",
    missingRenderedVideosFor: "Rendered videos missing for",
    clipNotFound: "Clip not found",
    loadClipDetailsError: "Error loading clip details",
    cancelUploadError: "Could not cancel clip upload",
    uploadCancelledFor: "Upload cancelled for",
    collectionProcessingModalTitle: "Stream processing",
    collectionProcessingModalTitleQueued: "Queued for processing",
    collectionProcessingModalTitleDownloading: "Downloading stream",
    collectionProcessingModalTitleDownloaded: "Processing stream",
    collectionProcessingModalTitleDecided: "Queued for rendering",
    collectionProcessingModalTitleRendering: "Creating your clips",
    collectionProcessingModalTitleFailed: "Processing failed",
    collectionProcessingModalMessage:
      "This stream is still being processed. Please be patient, you will be able to open the collection soon.",
    collectionProcessingModalMessageQueued:
      "Your stream is in the queue. Please be patient, processing will start soon.",
    collectionProcessingModalMessageDownloading:
      "We are downloading your stream. Please be patient, this will finish soon.",
    collectionProcessingModalMessageDownloaded:
      "The stream has been downloaded and we are preparing your clips. It will finish soon.",
    collectionProcessingModalMessageDecided:
      "Your stream is queued for rendering. Please be patient, almost there.",
    collectionProcessingModalMessageRendering:
      "We are rendering your clips. Please be patient, we are almost done.",
    collectionProcessingModalMessageFailed:
      "We are sorry for the inconvenience. We will review the error and contact you by email to compensate you.",
    collectionProcessingCurrentStatus: "Current status:",
    collectionActionsMenuAria: "Open collection actions",
    scrollCollectionsLeft: "Scroll row to the left",
    scrollCollectionsRight: "Scroll row to the right",
    scrollClipsLeft: "Scroll clips to the left",
    scrollClipsRight: "Scroll clips to the right",
    previewDefaultTitle: "Your clip is ready to publish",
    previewDefaultHandle: "your_channel",
    previewPickDateTime: "Choose date and time to publish",
    previewPendingTime: "pending time",
    autoGeneratedClips: "Automatically created clips",
    yourConnectedNetworks: "Your connected networks",
    connectedPlatforms: "Connected networks",
    magicPublish: "Magic publishing",
    publishNow: "Schedule",
    selectPublishNetworks: "Select publishing networks",
    selectDate: "Select the date",
    selectTime: "Select the time",
    selectTimezoneLabel: "Select the timezone",
    pickHour: "Choose hour",
    pickMinute: "Choose minute",
    pickTimeHint: "Select hour, minute, and AM or PM.",
    pickTimeHintShort: "You haven't chosen a time yet",
    dayPeriod: "Time of day",
    editClip: "Edit clip",
    sourceVod: "Source VOD",
    checkingConnection: "Checking...",
    platformConnected: "Connected",
    platformNotConnected: "Not connected",
    errorLoadAdminTimeline: "Could not load the timeline.",
    errorLoginToLoadTimeline: "You must sign in to view the timeline.",
    converterFolderTitle: "Converter PRO",
    converterFolderSubtitle: "Convert full Google Drive videos (max 5 minutes) in a single queue.",
    converterFolderHandle: "Google Drive",
    converterFolderOwner: "Converter PRO",
    converterFolderBadge: "CONVERTER",
    converterFolderSummary: "Google Drive conversions",
    converterPanelTitle: "Convert your full Drive video",
    converterPanelSubtitle: "Paste a public Google Drive URL (max 5 minutes), choose a video type, and confirm to process the full video.",
    converterStartFullVideo: "Convert full video",
    converterDrivePlaceholder: "https://drive.google.com/file/d/...",
    converterPrepareCta: "Prepare clip",
    converterInvalidDriveUrl: "Enter a valid Google Drive URL.",
    converterNoHistory: "You do not have conversions in this folder yet.",
    converterPrepareConfirmSubtitle: "Review the summary before queuing full Google Drive video conversion.",
    converterDurationMax: "Maximum 5 minutes",
    converterTokenChargeHint: "Final token charge uses the actual duration detected by the worker while processing the full video.",
    converterSelectionLabel: "Selected range",
    converterWatchRender: "Watch render",
    converterStatusPreparing: "Preparing",
    converterStatusQueuedRender: "Queued for render",
    converterStatusQueued: "Queued",
    converterStatusDownloading: "Downloading",
    converterStatusProcessing: "Processing",
    converterStatusRendering: "Rendering",
    converterStatusReadyToEdit: "Ready to edit",
    converterStatusFailed: "Failed",
    converterStatusRendered: "Rendered",
    converterActionRendered: "Clip rendered",
    converterActionFailed: "Conversion failed",
    converterActionProcessing: "Processing full video",
    converterLoadError: "Could not load converter history.",
    converterPrepareError: "Could not queue video conversion.",
    converterConfirmTitle: "Confirm full video conversion",
    converterEditorTitle: "Converter PRO editor",
    converterEditorNoTitle: "Converter job",
    converterEditorTab: "Editor",
    converterVideoTypeTab: "Video type",
    converterEndCardTab: "End-card",
    converterSummaryTab: "Summary",
    converterDurationHint: "Selected duration",
    converterEndCardHint: "The end-card will be applied with current render settings.",
    converterSummaryDuration: "Selected duration",
    converterSummaryVideoType: "Video type",
    converterSummaryTokens: "Tokens to charge",
    converterRenderConfirm: "Edit and render",
    converterRenderError: "Could not queue converter render.",
    converterConfirmAndQueue: "Confirm and convert video",
    backToStreams: "Back to streams",
    selectAll: "All",
    clearSelection: "Clear",
    download: "Download",
    downloadZip: "Download ZIP",
    preparingZip: "Preparing ZIP",
    zipDownloadSuccess: "ZIP downloaded successfully",
    selectClipForDownload: "Select clip to download",
  },
  vodClips: {
    subtitlesToggleLabel: "Show subtitles",
    vodStatus: "VOD status",
    noCollections: "No clip collections found",
    noCollectionsHint: "Create clips from a Twitch VOD to get started",
    vod: "VOD",
    processing: "Processing",
    downloading: "Downloading",
    preparingClips: "Preparing clips",
    creatingClips: "Creating your clips",
    rendering: "Rendering",
    inQueue: "In queue",
    validating: "Validating",
    vodList: "VOD list",
    clipCandidates: "Clip candidates",
    reassignVod: "Reassign VOD",
    deleting: "Deleting...",
    deleteVod: "Delete VOD",
    sendToError: "Send to failed",
    sendingToError: "Sending...",
    rerenderVod: "Rerender",
    rerenderVodFull: "Redownload and rerender",
    rerenderFailedClips: "Rerender failed clips",
    rerenderingVod: "Requeueing...",
    backToVods: "Back to VODs",
    previewWarning: "Important warning: This is a preview. Captions are not available yet (they are added in final render), video is horizontal now but will be converted to a vertical format centered on the face, and quality here is low; final output is delivered in high quality.",
    vodUrl: "VOD URL",
    publicUrl: "Public URL",
    copy: "Copy",
    period1d: "1 day",
    period3d: "3 days",
    period7d: "7 days",
    periodAll: "All",
    statusAll: "All",
    statusQueued: "Queued",
    statusRunning: "Running",
    statusDownloading: "Downloading",
    statusRendering: "Rendering",
    statusDownloaded: "Downloaded",
    statusDecided: "Decided",
    statusScheduling: "Scheduling",
    statusRendered: "Rendered",
    statusPublished: "Published",
    statusExpired: "Expired",
    statusInsufficientTokens: "Insufficient tokens",
    renderingModalTitle: "Rendering",
    renderingModalMessage: "This video is currently rendering.",
    publishedModalTitle: "Video already published",
    publishedModalMessage: "This VOD has already been published.",
    statusFailed: "Failed",
    failureNoSpeechIntroScan: "No speech detected",
    failureSourceVideoTooShort: "The stream/video is too short. Try a longer one",
    failureSourceSubscriberOnly: "This Kick VOD is set to active subscribers only. Change the VOD visibility to public.",
    statusCancelled: "Cancelled",
    publicUrlCopied: "Public URL copied.",
    publicUrlCopyError: "Could not copy the public URL.",
    vodUrlCopied: "VOD URL copied.",
    vodUrlCopyError: "Could not copy the VOD URL.",
    vodRendering: "VOD rendering",
    clipsRendered: "rendered clips",
    clipsInReview: "Clips in review",
    noClipsYet: "No clips have been generated yet",
    clipTime: "Clip time",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    mute: "Mute",
    unmute: "Unmute",
    play: "Play",
    pause: "Pause",
    playPreview: "Play preview",
    pausePreview: "Pause preview",
    loadingPreview: "Loading preview",
    previewTimeline: "Preview timeline",
    mutePreview: "Mute preview",
    unmutePreview: "Unmute preview",
    playClipAria: "Play clip",
    thumbnailAltPrefix: "Thumbnail",
    editor: "Editor",
    start: "Start",
    end: "End",
    duration: "Duration",
    video: "Video",
    edited: "Edited",
    editedTimingTooltip: "This clip has an edited time range (start/end).",
    reason: "Reason",
    clipContext: "Clip context",
    addShortContext: "Add short context",
    contextPlaceholder: "Ex: Epic stream moment...",
    accept: "Accept",
    reject: "Reject",
    pendingClipsDetected: "Pending clips detected",
    pendingInfoPart1: "Some clips are still undecided. If you continue, all pending clips will be automatically marked as",
    pendingQuestion: "Do you want to continue and reject all remaining pending clips?",
    pendingInfoPart2: "and they will be saved.",
    rejectedLower: "rejected",
    undecidedSuffix: "undecided",
    pendingPlural: "Pending",
    acceptedPlural: "Accepted",
    rejectedPlural: "Rejected",
    rejectPendingAndSave: "Reject pending and save",
    clipEditorTitle: "Clip editor",
    correctTranscript: "Correct transcript",
    transcriptVisibleRange: "Only blocks within the selected range are shown.",
    transcriptCorrectionOnly: "Use only to correct misinterpretations, spelling, or censor words.",
    transcriptSyncWarning: "Adding or removing words may desynchronize subtitles.",
    transcriptCensorHint: "Three or more consecutive asterisks mute the center of that word.",
    transcriptCensorExamples: "Examples: f***ing, sh****.",
    transcriptNoBlocksInRange: "There are no transcript blocks within the selected range.",
    transcriptLoadError: "Could not load the transcript.",
    applyTranscriptChanges: "Apply to editor",
    job: "Job",
    currentRange: "Current range",
    centerOriginalClip: "Center (original clip)",
    dragToMoveSelection: "Drag to move selection",
    adjustStartDrag: "Adjust start (drag)",
    selected: "Selected",
    adjustEndDrag: "Adjust end (drag)",
    newRange: "New range",
    extra: "Extra",
    addMusic: "Add music",
    song: "Song",
    selectSong: "Select a song",
    songStartSeconds: "Song start (seconds)",
    musicTimeline: "Music timeline",
    volume: "Volume",
    previewNewStart: "Go to new start in modal player",
    preview: "Preview",
    videoTypeTab: "Video type",
    contextTab: "Context",
    videoTypeLabel: "Video type",
    videoTypeWarning: "Choose the video type only if you are sure. If the selected format does not match the content, the system may use a centered vertical view and only the center of the screen will be visible.",
    videoTypeAuto: "Auto",
    videoTypeGameplay: "Split screen",
    videoTypeJustChatting: "Standard",
    videoTypeIRL: "Full video",
    videoTypePodcast: "Podcast",
    videoTypeCenter: "Vertical centered",
    videoTypeGuideTitle: "What each category does",
    videoTypeAutoDescription: "The worker analyzes the clip and automatically chooses the most suitable layout between gameplay, podcast, or conversational vertical format.",
    videoTypeGameplayDescription: "Your camera on top, content below.",
    videoTypeJustChattingDescription: "One single shot, centered.",
    videoTypeIRLDescription: "Everything stays visible, blurred background.",
    videoTypePodcastDescription: "Several people on screen.",
    videoTypeCenterDescription: "This category forces a fixed centered vertical framing of the full video, without prioritizing face detection.",
    contextPreviewHint: "This preview uses the edit video to simulate the vertical IRL layout. The final result may vary after rerender.",
    editorOriginalStreamLabel: "Original stream",
    editorClipPreviewLabel: "Clip preview",
    editorRenderVarianceHint: "The final render may look slightly different from this preview.",
    editorSubtitlePlaceholder: "Your subtitles will go here",
    layoutJustChattingCropLabel: "Vertical video",
    layoutGameplayCropLabel: "Gameplay",
    layoutFaceCropLabel: "Face",
    layoutDragHint: "Drag the boxes on the horizontal video to choose the vertical clip framing.",
    podcastPreviewUnavailable: "Preview not available for podcast",
    previewLayoutSaveError: "Could not save framing for this clip.",
    contextOnlyIrl: "You can only move the context box when video type is IRL.",
    contextBoxToggleLabel: "Show context box",
    contextBoxDisabledHint: "The IRL clip will render without a context box.",
    contextTextInputLabel: "Context text",
    contextTextInputPlaceholder: "Write or improve the context text that will appear on the IRL clip.",
    contextCompatibleEmojiTitle: "Compatible emojis",
    contextCompatibleEmojiHint: "These symbols render correctly in the final video.",
    insertContextEmoji: "Insert emoji",
    contextDragHint: "Drag the box to choose where context appears in IRL clips.",
    contextEmojiLabels: {
      happy: "Happy",
      sad: "Sad",
      heart: "Heart",
      classicHeart: "Classic heart",
      star: "Star",
      starOutline: "Star outline",
      sparkle: "Sparkle",
      sparkleOutline: "Sparkle outline",
      sun: "Sun",
      cloud: "Cloud",
      rain: "Rain",
      snow: "Snow",
      lightning: "Lightning",
      coffee: "Coffee",
      music: "Music",
      musicNote: "Music note",
      check: "Check",
      cross: "Cross",
      plane: "Plane",
      flag: "Flag",
      flagOutline: "Flag outline",
      clover: "Clover",
      moon: "Moon",
      moonOutline: "Moon outline",
      crown: "Crown",
      blackCrown: "Black crown",
      gear: "Gear",
      swords: "Swords",
      anchor: "Anchor",
      warning: "Warning",
    },
    contextTextMissing: "This clip does not have AI-generated context text.",
    contextSaveError: "Could not save this clip context.",
    premiumEditorRequiresPremium: "You need an active premium subscription to edit this clip.",
    premiumEditorScheduledBlocked: "Cancel the scheduled post before editing this clip.",
    premiumEditorPostedBlocked: "This clip is already posted and cannot be edited.",
    premiumEditorNotEditable: "This clip cannot be edited.",
    premiumEditorMissingEditSource: "This clip does not have an editing video available yet.",
    premiumEditorVideoLoadFailed: "Could not load this clip's edit video.",
    premiumEditorOriginalExpired: "This clip can no longer be edited because the original video has expired.",
    premiumEditorRerenderQueued: "Rerender queued. The clip will be updated in a few minutes.",
    premiumEditorRangeInvalid: "The new range must stay within ±15 seconds of the current clip.",
    premiumEditorRerenderError: "Could not queue clip rerender. Please try again.",
    personalizationSaveError: "Could not save personalization before rerendering.",
    selectUserToReassign: "Select a user to reassign this VOD.",
    confirmDeleteVodTitle: "Confirm VOD deletion",
    deleteVodPermanent: "This action is permanent and cannot be undone.",
    deleteVodWarning: "Once deleted, this VOD cannot be restored.",
    name: "Name",
    date: "Date",
    loadUsersError: "Could not load users",
    loadUsersErrorShort: "Could not load users.",
    noUsersMatchFilter: "No users match the filter.",
    selectedUserIdNotFound: "Selected user's user_id was not found.",
    vodReassignedTo: "VOD reassigned to",
    selectedUser: "selected user",
    reassignVodError: "Could not reassign VOD. Please try again.",
    authRequired: "Authentication is required",
    missingApiUrl: "Missing VUE_APP_API_URL",
    deleteVodError: "Error deleting VOD",
    vodDeleted: "VOD deleted.",
    deleteVodRetryError: "Error deleting VOD. Please try again.",
    releaseStuckTitle: "Send VOD to failed",
    releaseStuckSubtitle: "This action releases stuck jobs and preserves already rendered clips.",
    releaseStuckWarning: "If the job had a downloaded source or rendered clips, it will end as Rendered and only incomplete clips will be marked as failed.",
    releaseStuckError: "Could not send the VOD to failed. Please try again.",
    releaseStuckRenderedSuccess: "VOD released. Rendered clips were preserved.",
    releaseStuckFailedSuccess: "VOD sent to failed successfully.",
    rerenderVodConfirmTitle: "Redownload and rerender VOD",
    rerenderVodConfirmSubtitle: "Current clips will be removed and the VOD will be queued again.",
    rerenderVodWarning: "Use this option only when download failed. The system will restart processing from scratch.",
    rerenderFailedClipsSubtitle: "Only clips in failed status will be queued again.",
    rerenderFailedClipsWarning: "This option preserves good clips and only recovers failed clips.",
    rerenderVodSuccess: "The VOD was queued again successfully.",
    rerenderVodError: "Could not redownload and rerender the VOD. Please try again.",
    rerenderFailedClipsError: "Could not rerender failed clips. Please try again.",
    rerenderFailedClipsSuccess: "Failed clips queued again successfully.",
    statusRerenderFailed: "Rerender failed",
    publicJobIdNotFound: "job_id was not found in public URL.",
    loadCollectionsError: "An error occurred while loading collections. Please try again.",
    vodExpiredOpenSnackbar: "The VOD you want to open has expired, please rerender a new one.",
    unknown: "Unknown",
    unsavedDecisionChangesWarning: "You have unsaved changes in accepted/rejected clips. Are you sure you want to leave without saving?",
  },
  twitchPostAdmin: {
    timelineUsers: "Users timeline",
    users: "Users",
    total: "Total",
    scheduled: "Scheduled",
    posted: "Posted",
    usernameFilterPlaceholder: "Search username",
    addUsernameFilter: "Add",
    clearUsernameFilters: "Clear",
    removeUsernameFilter: "Remove username filter",
    showMyUsers: "Show my users",
    showAllUsers: "Show all users",
    assignAdmin: "Assign",
    assignAdminTitle: "Assign admin",
    timelineUser: "Assign user",
    unassignedAdmin: "Unassigned",
    assignedAdminUnknown: "Assigned admin",
    closeAssignAdmin: "Close admin assignment",
    loadingAdmins: "Loading admins...",
    noAdminsAvailable: "No admins available.",
    searchAdminPlaceholder: "Search admin",
    noAdminsMatchFilter: "No admins match the search.",
    assigningAdmin: "Assigning...",
    noUsersTimeline: "No users enabled for timeline.",
    noFilteredUsersTimeline: "No timelines for the filtered users.",
    noPosts: "no posts",
    previewTitle: "Scheduled clip preview",
    untitledClip: "Untitled clip",
    closePreview: "Close preview",
    loadingPreview: "Loading preview...",
    noVideo: "No video available for this clip.",
    user: "User",
    time: "Time",
    status: "Status",
    publishedUrls: "Published URLs",
    stream: "Stream",
    manageScheduledClip: "Manage scheduled clip",
    closeManageScheduledClip: "Close manage scheduled clip",
    clipId: "Clip ID",
    scheduledDate: "Scheduled date",
    scheduledTime: "Scheduled time",
    cancellingUpload: "CANCELLING...",
    cancelUpload: "CANCEL UPLOAD",
    previewLoadError: "Could not load clip preview.",
    previewUrlMissing: "No preview URL was found for this scheduled clip.",
  },
  publicResults: {
    title: "Rendered clips",
    job: "Job",
    empty: "No rendered clips were found for this job.",
    score: "SCORE",
    downloading: "Downloading...",
    download: "Download",
    deleting: "Deleting...",
    confirmDelete: "Confirm deletion",
    lastConfirmation: "Final confirmation",
    deleteStepOne: "This clip will no longer be shown in public results.",
    deleteStepTwo: "This action is permanent and cannot be undone.",
    selectedClip: "Selected clip",
    deleteWarning: "If you continue, the clip will be deleted and will no longer be available.",
    yesContinue: "Yes, continue",
    yesDeletePermanent: "Yes, delete permanently",
    downloadError: "Could not download clip.",
    downloadSuccess: "Clip downloaded successfully",
    downloadRetryError: "Error downloading clip. Please try again.",
    deleteError: "Could not delete clip.",
    deleteSuccess: "Clip deleted successfully",
    deleteRetryError: "Error deleting clip. Please try again.",
    invalidJobId: "Invalid job ID.",
    jobIdNotFound: "Job ID not found in URL.",
    status: {
      pending: "Pending",
      processing: "Processing",
      rendering: "Rendering",
      completed: "Completed",
      failed: "Failed",
      accepted: "Accepted",
      rejected: "Rejected",
      ready: "Ready",
      rendered: "Ready",
      readyToPost: "Ready to post",
      posted: "Posted",
      postFailed: "Post failed",
      inProgress: "In progress",
    },
  },
  usersList: {
    title: "Users",
    impersonating: "Impersonating",
    stopImpersonation: "Stop impersonation",
    stopImpersonationTitle: "Stop impersonating this user",
    addUser: "Add user",
    id: "ID",
    username: "Username",
    phone: "Phone",
    ageRange: "Age",
    email: "Email",
    origin: "Source",
    plan: "Plan",
    planFilter: "Plan",
    planFilterAll: "All",
    planFilterFree: "Free",
    planFilterNonFree: "Non-Free",
    admin: "Admin",
    timezone: "Timezone",
    createdAt: "Created at",
    actions: "Actions",
    loginAsUser: "Login as user",
    loadingUsers: "Loading users...",
    noUsersFound: "No users found.",
    searchPlaceholder: "Search user",
    searchUsersPlaceholder: "Search by username or email",
    noUsersMatchFilter: "No users match the search.",
    originFacebookAds: "Facebook Ads",
    originAdCampaign: "Campaign",
    originAdminGenerated: "Admin",
    originOrganic: "Organic",
    originUnknownExisting: "Historical",
    emptyHint: "Click \"Add user\" to create one.",
    editUser: "Edit user",
    createUser: "Create user",
    personalInfo: "Personal information",
    nameRequired: "Name*",
    usernamePlaceholder: "Username",
    emailPlaceholder: "email@example.com",
    avatarUrl: "Avatar URL",
    timezoneRequired: "Timezone*",
    selectTimezone: "Select timezone",
    accountInfo: "Account information",
    showInPostAdminTimeline: "Show in post admin timeline",
    availableTokens: "Available tokens",
    hasWatermark: "Watermark in clips",
    cancel: "Cancel",
    saving: "Saving...",
    update: "Update",
    create: "Create",
    confirmDelete: "Confirm delete",
    confirmDeleteUser: "Are you sure you want to delete user",
    cannotUndo: "This action cannot be undone.",
    deleting: "Deleting...",
    loadUsersError: "Failed to load users. Please try again.",
    impersonationStarted: "Impersonation started.",
    impersonationEnded: "Impersonation ended.",
    impersonationFailed: "Failed to impersonate user",
    avatarUrlInvalid: "URL must start with http:// or https://",
    requiredFieldsError: "Please fill all required fields correctly",
    updateUserError: "Failed to update user",
    createUserError: "Failed to create user",
    updateUserRetryError: "Failed to update user. Please try again.",
    createUserRetryError: "Failed to create user. Please try again.",
    deleteUserError: "Failed to delete user",
    deleteUserRetryError: "Failed to delete user. Please try again.",
    grantTokens: "Add PAYG tokens",
    grantTokensTitle: "Add PAYG tokens",
    targetUser: "User",
    tokensToAdd: "PAYG tokens to add",
    tokensPlaceholder: "e.g. 200",
    confirmGrantTokens: "Add tokens",
    grantingTokens: "Adding...",
    userIdMissing: "user_id was not found for this user.",
    userIdResolveError: "Could not resolve this user's user_id.",
    invalidTokens: "Enter a valid token amount (integer greater than 0).",
    grantTokensError: "Could not add PAYG tokens",
    grantTokensRetryError: "Could not add tokens. Please try again.",
    tokensGranted: "Tokens added successfully",
    balance: "Balance",
    sessionRequired: "You must be signed in.",
    onboardingQaTitle: "Question and answer",
    onboardingQaButtonTitle: "Onboarding answers",
    onboardingAnswerNotSet: "—",
  },
  subscriptionPlansAdmin: {
    title: "Subscription plans",
    subtitle: "Manage plan catalog, availability, and version history.",
    create: "New plan",
    createFirst: "Create first plan",
    filterByBillingCycle: "Filter by billing cycle",
    filterByCheckoutVisibility: "Filter by checkout visibility",
    filterTabsAria: "Filter plans by period",
    visibilityTabsAria: "Filter plans by checkout visibility",
    filterAll: "All",
    filterMonthly: "Monthly",
    filterYearly: "Yearly",
    visibilityAll: "All",
    visibilitySelectable: "Visible in checkout",
    visibilityHidden: "Hidden from checkout",
    reload: "Reload",
    reloading: "Reloading...",
    loading: "Loading plans...",
    empty: "No plans available.",
    emptyMonthly: "No monthly plans available.",
    emptyYearly: "No yearly plans available.",
    emptySelectable: "No plans visible in checkout.",
    emptyHidden: "No plans hidden from checkout.",
    emptyMonthlySelectable: "No monthly plans visible in checkout.",
    emptyYearlySelectable: "No yearly plans visible in checkout.",
    emptyMonthlyHidden: "No monthly plans hidden from checkout.",
    emptyYearlyHidden: "No yearly plans hidden from checkout.",
    version: "Version",
    selectable: "Selectable",
    edit: "Edit",
    showHistory: "View history",
    hideHistory: "Hide history",
    plan: "Plan",
    creditsPerPeriod: "Credits/period",
    period: "Period",
    priceOriginal: "Original price",
    priceLanding: "Landing price",
    priceApp: "App price",
    currency: "Currency",
    effectiveFrom: "Effective from",
    effectiveTo: "Effective to",
    noDescription: "No description",
    versionHistory: "Version history",
    noHistory: "No previous versions.",
    displayName: "Name",
    description: "Description",
    periodUnit: "Period unit",
    periodAmount: "Period amount",
    month: "Month",
    months: "Months",
    year: "Year",
    years: "Years",
    yes: "Yes",
    no: "No",
    editModalTitle: "Edit plan",
    createModalTitle: "Create new plan",
    newVersion: "New version",
    planCode: "Internal plan code",
    planCodePlaceholder: "pro_monthly_plus",
    planCodeHelpCreate: "Unique backend identifier. Use letters, numbers, hyphens, and underscores.",
    planCodeHelpLocked: "The internal code does not change when creating new versions.",
    currentAction: "Action",
    createNotice: "Saving will register a new plan and make it available for future subscriptions based on its configuration.",
    immutableNotice: "Saving will create a new immutable plan version. Active subscriptions keep their previous terms.",
    priceOriginalMarketing: "Original / marketing price",
    priceLandingPage: "Landing page price",
    priceAppBilling: "In-app / actual billing price",
    availableOnCheckout: "Available for checkout selection",
    cancel: "Cancel",
    confirm: "Confirm",
    confirmToggleTitle: "Confirm change",
    saving: "Saving...",
    saveNewPlan: "Create plan",
    saveNewVersion: "Save new version",
    authRequired: "You must be signed in to view this section.",
    loadError: "Error loading plans",
    createSuccess: "The plan was created successfully.",
    updateSuccess: "A new plan version was created successfully.",
    createError: "Could not create the plan.",
    updateError: "Could not save the new version.",
    toggleSuccess: "Availability updated successfully.",
    toggleError: "Could not update availability.",
    confirmEnableSelectable: "Enable this plan for checkout selection?",
    confirmDisableSelectable: "Hide this plan from checkout?",
    statusActiveSelectable: "Active and selectable",
    statusActiveHidden: "Active but hidden",
    statusInactive: "Inactive",
    validationPlanCodeLength: "The internal code must be between 2 and 80 characters.",
    validationPlanCodeFormat: "The internal code may only contain letters, numbers, hyphens, and underscores.",
    validationDisplayName: "Name must be between 2 and 120 characters.",
    validationDescription: "Description cannot exceed 500 characters.",
    validationCredits: "Credits per period must be an integer greater than 0.",
    validationPeriodUnit: "Period unit is invalid.",
    validationPeriodAmount: "Period amount must be an integer greater than 0.",
    validationPrices: "Prices must be numbers greater than or equal to 0.",
    validationCurrency: "Currency must be exactly 3 characters.",
  },
  newslettersAdmin: {
    title: "Emails",
    subtitle: "Manage Clipr newsletters and marketing.",
    tabsAria: "Email sections",
    tabNewsletters: "Newsletters",
    tabMarketing: "Marketing",
    tryLastSentAt: "Last sent",
    tryLastFailedAt: "Last failed",
    tryCampaign: "Campaign",
    marketingTitle: "Marketing Winback",
    marketingBody: "Admin dashboard to monitor the automatic Winback queue, states, and events.",
    marketingLoading: "Loading Marketing Winback...",
    marketingLoadError: "Could not load Marketing Winback.",
    marketingStatesError: "Could not load Marketing states.",
    marketingPreviewTitle: "Marketing Winback preview",
    marketingPreviewHelp: "Renders a winback variant without sending email.",
    marketingPreviewValidation: "Name and unsubscribe URL are required.",
    marketingPreviewError: "Could not generate the Marketing preview.",
    marketingAutomationTitle: "Automation active",
    marketingAutomationHelp: "The cron syncs eligible candidates and sends at most 6 emails per run. This screen only monitors queue, states, and events.",
    marketingNoCampaigns: "No Marketing deliveries found.",
    marketingStates: "Marketing states",
    marketingStatesLoading: "Loading Marketing states...",
    marketingNoStates: "No Marketing states for those filters.",
    marketingUnsubscribed: "Unsubscribed",
    marketingOpens: "Opens",
    marketingClicks: "Clicks",
    marketingConversions: "Conversions",
    marketingByCycle: "By cycle",
    marketingByStep: "By step",
    marketingBySegment: "By segment",
    marketingByTokenState: "By token_state",
    marketingStatusActive: "Active",
    marketingStatusCooldown: "Cooldown",
    marketingStatusConverted: "Converted",
    marketingStatusExhausted: "Exhausted",
    marketingStatusPaused: "Paused",
    marketingSegmentGenerated: "Generated content",
    marketingSegmentNotGenerated: "No generated content",
    marketingTokenHasTokens: "Has tokens",
    marketingTokenNoTokens: "No tokens",
    marketingEngagementCold: "Cold",
    marketingEngagementWarm: "Warm",
    marketingEngagementEngaged: "Engaged",
    totalStates: "States",
    totalDeliveries: "Deliveries",
    processed: "Processed",
    eligible: "Eligible",
    skipped: "Skipped",
    createdDeliveries: "Created deliveries",
    reasons: "Reasons",
    campaign: "Campaign",
    filterByEmail: "Filter by email",
    search: "Search",
    clear: "Clear",
    breakdown: "Breakdown",
    noData: "No data",
    segment: "Segment",
    tokenState: "Tokens",
    cycle: "Cycle",
    step: "Step",
    engagement: "Engagement",
    openedAt: "Open",
    clickedAt: "Click",
    convertedAt: "Converted",
    unsubscribeUrl: "Unsubscribe URL",
    create: "New newsletter",
    createFirst: "Create first newsletter",
    generate: "Generate with AI",
    generateTitle: "Generate newsletters with AI",
    generateHelp: "AI only creates drafts. An admin must review and approve them before sending.",
    generateCount: "Count",
    generateLanguage: "Language",
    generateLanguageEs: "Spanish",
    generateLanguageEn: "English",
    generateTopics: "Topics",
    generateTopicsHelp: "Write one topic per line. The backend uses a fixed prompt and validates that the response completes the template.",
    generating: "Generating...",
    generateDrafts: "Generate drafts",
    reload: "Reload",
    reloading: "Reloading...",
    filterByStatus: "Filter by status",
    loading: "Loading newsletters...",
    empty: "No newsletters available.",
    newsletter: "Newsletter",
    subject: "Subject",
    status: "Status",
    scheduledAt: "Scheduled",
    updatedAt: "Updated",
    actions: "Actions",
    preview: "Preview",
    edit: "Edit",
    approve: "Approve",
    reject: "Reject",
    schedule: "Schedule",
    sendTest: "Send test",
    deliveries: "Deliveries",
    delete: "Delete",
    editModalTitle: "Edit newsletter",
    createModalTitle: "Create newsletter",
    editorHelp: "Complete the fields used by the HTML template so preview and sending do not fail.",
    internalTitle: "Internal title",
    emailSubject: "Email subject",
    cancel: "Cancel",
    saving: "Saving...",
    save: "Save",
    previewTitle: "Newsletter preview",
    previewName: "Preview name",
    previewEmail: "Preview email",
    loadingShort: "Loading...",
    refresh: "Refresh",
    loadingPreview: "Generating preview...",
    sendTestTitle: "Send test email",
    recipientName: "Name",
    recipientEmail: "Email",
    sending: "Sending...",
    send: "Send",
    scheduleTitle: "Schedule newsletter",
    scheduleHelp: "This will be sent to the backend as a UTC datetime with timezone.",
    deliveriesTitle: "Deliveries",
    deleteTitle: "Delete newsletter",
    deleteWarning: "This action will permanently delete the template and cannot be undone.",
    deleting: "Deleting...",
    confirmDelete: "Delete permanently",
    total: "Total",
    pending: "Pending",
    sent: "Sent",
    cancelled: "Cancelled",
    failed: "Failed",
    email: "Email",
    sentAt: "Sent",
    error: "Error",
    noDeliveries: "No deliveries for this newsletter.",
    loadingDeliveries: "Loading deliveries...",
    statusAll: "All",
    statusDraft: "Draft",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    statusScheduled: "Scheduled",
    statusSending: "Sending",
    statusSent: "Sent",
    statusCancelled: "Cancelled",
    authRequired: "You must be signed in to view this section.",
    loadError: "Could not load newsletters.",
    validationTitleSubject: "Title and subject are required.",
    validationContent: "Complete all content fields.",
    generateCountValidation: "Count must be between 1 and 30.",
    generateLanguageValidation: "Select a valid language.",
    generateTopicsValidation: "Add at least one topic.",
    generateSuccess: "{count} newsletters generated successfully.",
    generateError: "Could not generate newsletters.",
    createSuccess: "Newsletter created successfully.",
    updateSuccess: "Newsletter updated successfully.",
    saveError: "Could not save the newsletter.",
    approveSuccess: "Newsletter approved successfully.",
    approveError: "Could not approve the newsletter.",
    rejectSuccess: "Newsletter rejected successfully.",
    rejectError: "Could not reject the newsletter.",
    previewValidation: "Preview name and email are required.",
    previewError: "Could not generate the preview.",
    sendTestSuccess: "Test email sent successfully.",
    sendTestError: "Could not send the test email.",
    scheduleValidation: "Select a valid date.",
    scheduleSuccess: "Newsletter scheduled successfully.",
    scheduleError: "Could not schedule the newsletter.",
    deliveriesError: "Could not load deliveries.",
    deleteSuccess: "Newsletter deleted successfully.",
    deleteError: "Could not delete the newsletter.",
  },
  nav: {
    streamerProfile: "Profile",
    streamerProfileDescription: "Configure your social connections and preferences",
    createClips: "Create clips",
    createClipsDescription: "Create and segment your VODs to generate clips",
    clipsShort: "Clips",
    agenda: "Agenda",
    agendaDescription: "View your scheduled and published posts",
    analysis: "Analysis",
    analysisDescription: "Coming soon: your clip performance",
    comingSoonTag: "Coming soon",
    unlimitedTag: "Unlimited",
    mobileBottomNav: "Primary navigation",
    toggleSidebar: "Toggle navigation",
    studio: "Studio",
    studioDescription: "Convert full Drive videos to create clips",
    vodClips: "VOD clips",
    vodClipsDescription: "Manage your clips and revisions",
    dashboard: "Dashboard",
    results: "Results",
    schedulePost: "Schedule post",
    billing: "Plans",
    affiliateProgram: "Affiliates",
    twitchPostAdmin: "Twitch Post Admin",
    cliprPurchases: "Clipr Purchases",
    subscriptionPlansAdmin: "Subscription plans",
    newsletters: "Emails",
    manageUsers: "Manage users",
    userProfile: "User profile",
    usersAdmin: "Users admin",
    uploadContent: "Upload content",
    suggestions: "Suggestions",
    help: "Help",
    helpBack: "Back",
    tutorials: "Tutorials",
    logout: "Log out",
    admin: "Admin",
  },
  suggestions: {
    eyebrow: "YOUR FEEDBACK",
    title: "Share a suggestion",
    intro: "Tell us what you would improve in Clipr.",
    category: "Suggestion type",
    categoryPlaceholder: "Select an option",
    idea: "New idea",
    improvement: "Improvement",
    problem: "Problem",
    other: "Other",
    subject: "Subject",
    subjectPlaceholder: "Summarize your suggestion",
    description: "Description",
    descriptionPlaceholder: "Describe your idea or problem in as much detail as possible",
    successNotice: "Suggestion sent. Thanks for sharing your feedback.",
    authRequired: "You must sign in to send a suggestion.",
    submit: "Send suggestion",
    submitting: "Sending...",
  },
  agenda: {
    title: "Agenda",
    subtitle: "Your scheduled and published posts",
    loginRequired: "You must sign in to view your agenda.",
    view: "Agenda view",
    agendaView: "Agenda",
    monthView: "Month",
    scheduled: "Scheduled",
    published: "Published",
    more: "more",
    noEvents: "There are no scheduled clips in this period.",
    noEventsForDay: "There are no scheduled clips on this day.",
  },
  analysis: {
    status: "UNDER CONSTRUCTION",
    title: "Analysis is on the way",
    description: "Soon you will understand your clips' performance and discover what content works best.",
  },
  welcome: {
    eyebrow: "START HERE",
    title: "Welcome to Clipr",
    subtitle: "Learn the workflow for turning your streams into clips ready to publish.",
    comingSoon: "COMING SOON",
    featuredLabel: "WELCOME VIDEO",
    featuredTitle: "Welcome to Clipr",
    featuredDescription: "A quick tour of everything you can do with Clipr.",
    videoCreateTitle: "Create your first clip",
    videoCreateDescription: "Process a stream and find its best moments.",
    videoEditTitle: "Edit your clips",
    videoEditDescription: "Fine-tune the final cut before rendering.",
    videoScheduleTitle: "Schedule your posts",
    videoScheduleDescription: "Leave your clips ready to publish.",
    videoConnectionsTitle: "Connect your networks",
    videoConnectionsDescription: "Link your platforms to publish from Clipr.",
  },
  dashboard: {
    title: "Analytics",
    subtitle: "Connect your social networks and track your growth.",
    loading: "Loading...",
    reload: "Reload",
    data: "Dashboard data",
    totalImpressions: "Total impressions",
    totalImpressionsNoData: "No total impressions data available to display.",
    impressionsTimelineTitle: "Evolution by date",
    impressionsTimelineNoDataByDate:
      "No date-based data was found in the response to build the comparison chart.",
    viewFullDataJson: "View full data (JSON)",
    timelineTooltipDatePrefix: "Date:",
    timelineTooltipImpressionsSuffix: "impressions",
    timelineNoData: "No data available",
    facebookConfigTooltip: "Configure Facebook Page ID",
    facebookModalTitle: "Facebook settings",
    facebookPageIdTitle: "Page analytics",
    facebookPageIdHint: "Select your Facebook page so metrics load correctly.",
    facebookPageIdLabel: "Facebook page",
    facebookPageIdPlaceholder: "Select a page",
    facebookPageConnectFirst: "Connect Facebook first",
    loadingFacebookPages: "Loading Facebook pages...",
    facebookPagesLoadError: "Could not load your Facebook pages.",
    facebookPagesEmpty: "No Facebook pages available for this account.",
    facebookPageUnknownName: "Saved page",
    facebookPageIdSaving: "Saving...",
    facebookPageIdSave: "Save",
    facebookPageIdUpdate: "Update",
    facebookPageIdLoginRequired: "You must be signed in to update the Page ID.",
    emptyNoConnectionsTitle: "Connect your social networks",
    emptyNoConnectionsBody:
      "You do not have any social networks connected yet. Connect them to start viewing metrics and uploading content from Clipr.",
    emptyNoConnectionsCta: "Connect your social networks",
    firstVideoCta: "Download first video",
    emptyNoClipsTitle: "Create your first clip",
    emptyNoClipsBody:
      "You do not have any clips yet. Start with your first clip to begin seeing activity in your dashboard.",
    videoImpressionsSyncButton: "Refresh video impressions",
    videoImpressionsSyncModalTitle: "Refresh video impressions",
    videoImpressionsSyncLimitLabel: "Clip limit",
    videoImpressionsSyncStartDateLabel: "Start date",
    videoImpressionsSyncEndDateLabel: "End date",
    videoImpressionsSyncHint:
      "Up to {limit} published clips between {startDate} and {endDate} will be refreshed, starting from the most recent.",
    videoImpressionsSyncSubmit: "Refresh impressions",
    videoImpressionsSyncSubmitting: "Refreshing...",
    videoImpressionsSyncSummary:
      "Sync completed. Updated {updated} of {processed} clips; {failed} had no metrics and {skipped} were skipped.",
    videoImpressionsSyncLimitError: "Limit must be an integer between 1 and 100.",
    videoImpressionsSyncDateError: "Select a valid range (start date must be before or equal to end date).",
    videoImpressionsSyncLoginRequired: "You must be signed in to refresh video impressions.",
    videoImpressionsSyncGenericError: "Could not refresh video impressions.",
    noSocialConnectionsMessage:
      "You do not have any social networks connected yet. Connect at least one network from your profile to view these metrics.",
  },
  login: {
    forgotTitle: "Reset Password",
    forgotDescription:
      "Enter your email address and we'll send you a link to reset your password.",
    emailLabel: "Email",
    placeholderEmail: "Enter your email",
    resetSending: "Sending Link...",
    resetSendLink: "Send Reset Link",
    backToLogin: "Back to Login",
    signupTitle: "Create your account",
    signupDescription:
      "Enter your details to activate your account and start transforming your content with Clipr.",
    fullNameLabel: "Full Name",
    namePlaceholder: "e.g. John Doe",
    passwordLabel: "Password",
    confirmPasswordLabel: "Confirm Password",
    placeholderCreatePassword: "Create a password",
    placeholderRepeatPassword: "Repeat your password",
    reqMinChars: "Minimum 8 characters",
    reqUppercase: "At least one uppercase letter",
    reqNumber: "At least one number",
    reqSpecial: "At least one special character",
    creatingAccount: "Creating account...",
    createAccount: "Create Account",
    orSeparator: "OR",
    signUpWithGoogle: "Sign up with Google",
    alreadyHaveAccount: "Already have an account?",
    signInLink: "Sign In",
    welcomeTitle: "Welcome Back!",
    welcomeDescription:
      "Sign in to turn your footage into engaging short videos for all your platforms.",
    forgotPasswordLink: "Forgot Password?",
    placeholderPassword: "Enter your password",
    signingIn: "Signing in...",
    signInButton: "Sign In",
    continueWithGoogle: "Continue with Google",
    dontHaveAccount: "Don't have an account?",
    signUpLink: "Sign Up",
    promoTitle: "Transform Your Content with AI-Powered Video Creation.",
    testimonialQuote:
      "Clipr has revolutionized our content workflow. We upload our footage once, and AI automatically creates and publishes daily short videos across all platforms. It's like having a full video production team working 24/7.",
    testimonialName: "Michael Carter",
    testimonialRole: "Content Creator at DevCore",
    teamsTitle: "JOIN 1K TEAMS",
    errorLoginGeneric: "An error occurred during login",
    errorGoogleLogin: "An error occurred during Google login",
    signupAllFieldsRequired: "All fields are required.",
    signupPasswordRequirements: "Password does not meet security requirements.",
    signupPasswordsMismatch: "Passwords do not match.",
    signupErrorGeneric: "An error occurred while creating account.",
    signupSuccessSimple: "Account created. You can sign in.",
    resetEmailRequired: "Please enter your email address.",
    resetEmailSent: "Check your email for the password reset link.",
    resetErrorGeneric: "An error occurred sending reset link.",
    oauthErrorGeneric: "Authentication failed. Please try again.",
  },
  updatePassword: {
    title: "Set new password",
    description: "Create a new password to keep your Clipr account secure.",
    newPasswordLabel: "New password",
    newPasswordPlaceholder: "Enter new password",
    updating: "Updating...",
    submit: "Update password",
    success: "Password updated successfully. Redirecting to login...",
    errorGeneric: "An error occurred updating password.",
  },
  notFound: {
    title: "This page does not exist",
    subtitle: "The link may be outdated or the page may have moved. Go back to Create Clips to keep working.",
    backToCreateClips: "Back to Create Clips",
  },
  affiliateProgram: {
    eyebrow: "Clipr Partners",
    title: "Affiliate Program",
    subtitle: "Recommend Clipr and earn 30% from every subscription payment.",
    backToProfile: "Back to profile",
    loading: "Loading program...",
    joinTitle: "Turn recommendations into income",
    joinDescription: "Earn 30% from every payment for the lifetime of each subscription you refer. Your link is ready instantly.",
    benefitLifetime: "30% recurring for life",
    benefitHold: "Commissions become payable after 30 days",
    benefitPayout: "Manual payouts through SPEI or PayPal",
    benefitPremiumBonus: "With your first $25 USD payout, you receive a complimentary annual Clipr Premium subscription",
    acceptPrefix: "I accept the",
    termsLink: "program terms",
    enrolling: "Generating...",
    generateLink: "Generate my link",
    yourLink: "Your personal link",
    shareLink: "Share link",
    copyLink: "Copy link",
    customizeUrl: "Customize URL",
    hideCustomizeUrl: "Hide",
    codePlaceholder: "your-code",
    customizeCode: "Customize your code",
    codeHint: "Use letters, numbers, and hyphens. Your previous codes will keep working and remain reserved for you.",
    saveCode: "Save",
    savingCode: "Saving...",
    codeSaved: "Saved",
    codeTaken: "That code is already reserved.",
    lastClick: "Your link stays linked to the user for 90 days. If they sign up in that period, they're attributed to you.",
    copied: "Copied",
    copy: "Copy",
    activityTitle: "Activity",
    activitySubtitle: "Traffic and conversions from your link.",
    clicks: "Clicks",
    signups: "Signups",
    payingReferrals: "Paying referrals",
    payingReferralsShort: "Paying",
    earningsTitle: "Earnings",
    earningsSubtitle: "Commissions by payout status.",
    pending: "Pending",
    payable: "Payable",
    paid: "Paid",
    requestPayout: "Request payout",
    payoutReady: "Ready to request",
    payoutNotReady: "Not available yet",
    payoutHint: "Available from $25 USD. WhatsApp is required to send the request.",
    preparingWhatsApp: "Preparing...",
    openWhatsApp: "Request through WhatsApp",
    payoutHistoryTitle: "Payout history",
    payoutHistorySubtitle: "Check the status of your payout requests.",
    requestedAt: "Requested",
    amount: "Amount",
    status: "Status",
    paidAt: "Paid",
    noPayouts: "You have not requested any payouts yet.",
    payoutRequested: "Requested",
    payoutPaid: "Paid",
    payoutRejected: "Rejected",
    monthlyTitle: "Monthly summary",
    monthlySubtitle: "Clicks, signups, and commissions by month.",
    month: "Month",
    noActivity: "No activity to show yet.",
    authRequired: "You must sign in.",
    profileTitle: "Affiliate Program",
    profileDescription: "Get your link and earn 30% recurring from every referred subscription.",
    faqOpen: "Common questions",
    faqClose: "Close",
    faqEyebrow: "Help",
    faqTitle: "Common questions",
    faq: {
      q1: "How much do I earn?",
      a1: "You earn 30% of every payment made by the person you invite.",
      q2: "Do I only get paid once?",
      a2: "No. Every time your referral pays for their plan, you get your share. If they keep paying month after month, you keep earning.",
      q3: "When can I withdraw my money?",
      a3: "You wait 30 days first. After that, the money shows as payable and you can request your payout.",
      q4: "How much do I need to request a payout?",
      a4: "You need at least $25 USD in payable balance.",
      q5: "How do I get paid?",
      a5: "Once you reach $25, tap the WhatsApp button in your dashboard and send your request. We pay through SPEI or PayPal.",
      q6: "How do I use my link?",
      a6: "Share it with anyone. If someone visits with your link and signs up, they stay linked to you for 90 days from their last visit with your link.",
      q7: "What are pending, payable, and paid?",
      a7: "Pending: still waiting. Payable: you can request your payout. Paid: we already sent it to you.",
      q8: "Can I use my own link?",
      a8: "No. You only earn when you invite other people.",
      q9: "Who counts as a referral?",
      a9: "It has to be someone new who signs up with your link and pays for a premium plan. If they already had an account or do not pay for the plan, you do not earn a commission.",
    },
  },
  userProfile: {
    streamerProfileTitle: "User profile",
    streamerProfileDescription:
      "Set your language and connect your social accounts.",
    clipSubtitlesTitle: "Subtitles",
    clipSubtitlesDescription: "Auto subtitles on new clips.",
    clipSubtitlesSwitchAria: "Enable subtitles on clips",
    subtitleStyleTitle: "Style",
    subtitleStyleEdit: "Edit",
    subtitleStyleModalTitle: "Subtitle style",
    subtitleStyleModalHint: "Applies to new clips.",
    subtitleStyleFont: "Font",
    subtitleStyleEffect: "Highlight type",
    subtitleStyleEffectTextColor: "Text color",
    subtitleStyleEffectBackground: "Highlight",
    subtitleStyleColor: "Color",
    subtitleStylePreviewSuffix: "is the best",
    minimalProfileSubtitle:
      "Choose your interface language and connect accounts to publish.",
    socialSectionTitle: "Social accounts",
    socialSectionDesc: "Connect your accounts to publish and sync content.",
    freeSectionTitle: "Preferences",
    freeSectionSubtitle:
      "You can change the display name on your clips, the interface language, and the timezone.",
    proSectionTitle: "PRO features",
    proSectionSubtitle:
      "Connect your social accounts to publish and sync, and customize your clips’ end-card logo.",
    proBadgeAriaLabel: "PRO plan",
    savePreferences: "Save changes",
    notConnected: "Not connected",
    connected: "Connected",
    manage: "Manage",
    connect: "Connect",
    returnToProfile: "Back to profile",
    connectionPageOpened: "Connection page opened",
    facebookPageIdRegion: "Facebook Page ID settings",
    facebookPageIdTitle: "Page analytics",
    facebookPageIdHint:
      "Search and select your Facebook page so metrics load correctly.",
    facebookPageIdLabel: "Facebook page",
    facebookPageSearchPlaceholder: "Search by page name or ID",
    refreshFacebookPages: "Refresh",
    loading: "Loading...",
    loadingFacebookPages: "Loading Facebook pages...",
    facebookPagesLoadError: "Could not load your Facebook pages.",
    facebookPagesEmpty: "No Facebook pages available for this account.",
    facebookPagesNoResults: "No pages match your search.",
    facebookPageUnknownName: "Saved page",
    facebookPageIdPlaceholder: "Pick a page",
    facebookPageConnectFirst: "Connect Facebook first",
    facebookPageUnifiedPlaceholder: "Connect, pick your page",
    saving: "Saving…",
    savePageId: "Save",
    updatePageId: "Update",
    facebookPageIdSaved: "Facebook Page ID updated successfully",
    facebookPageIdRequired: "Page ID is required",
    languageTitle: "Interface language",
    preferencesTitle: "User preferences",
    languageHint: "Choose the language you want to use across the platform.",
    languageSaved: "Language updated successfully",
    languageSaveError: "Error saving language",
    timezoneTitle: "Scheduling timezone",
    timezoneHint: "Set the timezone used when scheduling clips.",
    timezoneLabel: "Timezone",
    selectTimezone: "Select timezone",
    timezoneSaved: "Timezone updated successfully",
    timezoneSaveError: "Error saving timezone",
    timezoneRequired: "Please select a timezone",
    personalizationTitle: "Personalization",
    personalizationHint:
      "Adjust the branding shown at the end of your rendered clips.",
    customLogoTitle: "End card logo for your clips",
    customLogoHint:
      "Upload a transparent PNG for the end screen. If you do not upload one, the default Clipr logo will be used. You can also turn off the end screen entirely with the switch below.",
    customLogoLabel: "PNG file",
    customLogoBrowseButton: "Choose file",
    customLogoFileHint:
      "Transparent PNG · max 2 MB · max 1024×1024 px. Choose a file.",
    customLogoSaved: "Logo updated successfully",
    customLogoSaveError: "Error saving logo",
    customLogoInvalidFile: "Only PNG files (.png) are allowed.",
    customLogoFileTooLarge: "The file exceeds the maximum size of 2 MB.",
    customLogoDimensionsTooLarge: "The image exceeds the maximum size of 1024×1024 px.",
    customLogoImageReadError: "Could not read the image. Make sure it is a valid PNG.",
    customLogoPreviewAlt: "Logo preview",
    adminBrandingTitle: "End card and watermark",
    adminBrandingHint: "Customize the elements shown on your clips.",
    adminOnlyBadge: "ADMIN ONLY",
    adminWatermarkTitle: "Custom watermark",
    adminWatermarkHint:
      "This image replaces Clipr's default watermark when your watermark is enabled.",
    adminWatermarkPreviewLabel: "Preview",
    adminWatermarkPreviewAlt: "Watermark preview",
    adminWatermarkEmptyState:
      "No custom watermark configured. Clipr's default watermark will be used.",
    adminWatermarkFileLabel: "PNG file",
    adminWatermarkBrowseButton: "Choose file",
    adminWatermarkFileHint: "PNG · max 2 MB.",
    adminWatermarkInvalidFile: "Only PNG files (.png) are allowed.",
    adminWatermarkFileTooLarge: "The file exceeds the maximum size of 2 MB.",
    adminWatermarkSaved: "Custom watermark updated successfully",
    adminWatermarkSaveError: "Error saving custom watermark",
    adminWatermarkSessionError: "Error: session not found. Please sign in again.",
    activeVideoEndcardLabel: "Show end screen (logo and name) on clips",
    activeVideoEndcardSaved: "End screen preference updated",
    activeVideoEndcardSaveError: "Could not save end screen preference",
    activeVideoEndcardSwitchAria: "Turn end screen on or off for your clips",
    customLogoSectionSavedBoth: "End screen and logo updated successfully",
    endCardTab: "End card",
    displayNameTitle: "Username",
    displayNameHint:
      "This is the name shown on your clips’ end card and in your profile.",
    displayNameLabel: "Display name",
    displayNameSaved: "Name updated successfully",
    displayNameSaveError: "Error saving name",
    displayNameRequired: "Please enter a name.",
    sessionError: "Error: User session not found. Please log in again.",
    fontSettings: {
      title: "Font settings",
      fontName: "Font name",
      fontColor: "Font color",
      fontWeight: "Font weight",
      hexColorHint: "Select or enter a hex color code",
      weightThin: "Thin",
      weightExtraLight: "Extra Light",
      weightLight: "Light",
      weightRegular: "Regular",
      weightMedium: "Medium",
      weightSemiBold: "Semi Bold",
      weightBold: "Bold",
      weightExtraBold: "Extra Bold",
      weightBlack: "Black",
      hexColorError: "Please enter a valid hex color (e.g., #000000)",
      saveSuccess: "Font settings saved successfully!",
      saveError: "Error saving font settings",
    },
  },
};
